import React, { useEffect, useState, useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";
import NoAttachmentsImage from "../../images/Clear-filter.svg";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Pagination,
} from "@mui/material";
import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import { INVOICE_LIST } from "../../constants/RoutePath";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import { AccountCircle } from "@mui/icons-material";
import pdfMainLogo from "../../images/HOS-preview-logo.svg";
import Paper from "@mui/material/Paper";
import { billTypeList } from "../comman/Constant";
import {
  GET_INVOICE_REPORT_URL,
  GET_CUSTOMER_BY_ID_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  GET_DAY_AND_MILEAGE_RATE_URL,
  GET_INVOICE_PDF_ATTACHMENTS_API,
} from "../../constants/ApiRoute";
import API from "../comman/API";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader, getStatementId } from "../comman/MainFunction";
import {
  formatBrokerChargeLine,
  getBrokerChargeBreakdown,
  getBrokerChargeTotal,
  getTotalOwed,
} from "./printTotalOwed";
const moment = require("moment");

const getPrintBrokerCharges = (lineItems = [], header = {}) =>
  getBrokerChargeBreakdown(lineItems, {
    "Billable Rate": header.BillableDayRate ?? header.dayRate,
    "Principal Rate": header.SelectedPrincipalRate ?? header.selectedPrincipalRate,
    "Project Manager Rate": header.SelectedProjectManagerRate ?? header.selectedProjectManagerRate,
    "Field Agent Rate": header.SelectedFieldAgentRate ?? header.selectedFieldAgentRate,
  });

const getPrintDayRateType = (item = {}) => {
  const value =
    item?.selectedDayRate ?? item?.InvSelectedDayRate ?? item?.SelectedDayRate;
  return !value || value === "Default" ? "Billable Rate" : value;
};
import html2canvas from "html2canvas";
import htmlDocx from "html-docx-js/dist/html-docx";
import * as XLSX from "xlsx";
import CustomPageLoading from "../comman/CustomPageLoading";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { getAllStatesList } from "../../redux/action";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist";

export default function PrintConsolidatedInvoice(props) {
  const captureRef = useRef();
  const [downloadType, setDownloadType] = React.useState("Save as");
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  let invoiceId = isNaN(lastPart) ? null : lastPart;
  const [loading, setLoading] = useState(false);
  const [tableUpdatedData, settableUpdatedData] = useState([]);

  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [invoiceData, setInvoiceData] = useState([]);
  const [consolidateInvoiceData, setConsolidateInvoiceData] = useState([]);
  console.log(
    consolidateInvoiceData,
    "consolidateInvoiceDataconsolidateInvoiceData"
  );
  console.log(invoiceData, "invoiceDatainvoiceDatainvoiceData");
  const [invoiceTotalOwned, setInvoiceTotalOwned] = useState(0);
  const [invoiceTotalStatic, setInvoiceTotalStatic] = useState(0);
  console.log(invoiceTotalStatic, "invoiceTotalStatic", invoiceTotalOwned);
  const [customerData, setCustomerData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [invoiceTableData, seInvoiceTableData] = useState([]);
  const [billngStatementTableData, seBillngStatementTableData] = useState([]);
  const [zoomPgae, setZoomPgae] = useState(0);
  const [fullPageView, setFullPageView] = useState(false);
  const [currentPrintDate, setCurrnetPrintDate] = useState("");
  const navigate = useNavigate();
  const stateList = deCryptFun(useSelector((s) => s?.AllStateListReducer));
  const stateListsIds = stateList ? JSON.parse(stateList)?.data : "";
  const dispatch = useDispatch();
  console.log(stateListsIds, "stateheehjkehje");
  const matchingState =
    stateListsIds &&
    stateListsIds.find(
      (state) =>
        String(state.countyId) === String(invoiceData[0]?.InvoiceBillToState)
    );
  const [previewDetails, setPreviewDetails] = useState([]);
  const [pdfViewer, setpdfViewer] = useState(false);
  const [consDataDownload, setConsDataDownload] = useState([]);

  console.log(consDataDownload,'consDataDownloadconsDataDownload')

  useEffect(() => {
    if (invoiceId) {
      getInvoicePrintViewDetail(invoiceId);
      getAttachmentPDFApi(invoiceId);
      dispatch(getAllStatesList());
      // getProjectDetail();
    }
  }, [invoiceId]);

  const handleChangeZoomPage = (event) => {
    var selectedValue = event.target.value;
    setZoomPgae(selectedValue);
  };

  const periodKeyToDate = (value) => {
    // Extract start and end date components
    const startDateStr = value.substring(0, 8); // "01062024"
    const endDateStr = value.substring(8); // "10062024"

    // Parse the dates using moment with the correct format
    const startDate = moment(startDateStr, "MMDDYYYY", true);
    const endDate = moment(endDateStr, "MMDDYYYY", true);

    // Check if both dates are valid
    if (!startDate.isValid() || !endDate.isValid()) {
      return "Invalid Date";
    }

    // Format the dates
    const formattedStartDate = startDate.format("MM/DD/YYYY");
    const formattedEndDate = endDate.format("MM/DD/YYYY");

    // Combine the formatted dates
    return `${formattedStartDate} - ${formattedEndDate}`;
  };

  const getInvoicePrintViewDetail = async (invoiceId) => {
    setLoading(true);
    let data = {
      invoiceId: invoiceId,
    };

    const config = {
      method: "GET",
      url: GET_INVOICE_REPORT_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("INVOICE DATA ==> ", parsedResponse);
      var summedDataTotalOwned = 0;
      setCurrnetPrintDate(moment.utc().format("MM/DD/YYYY h:mm:ss A"));

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        const ConsolidatedInvoiceDetails =
          parsedResponse.data[0].ConsolidatedInvoiceDetails;
        const invoiceDetails = parsedResponse.data[0].invoiceDetails;
        const dayAndMileageRateResponse =
          await getDayAndMileageRateRecentData();
        setInvoiceData(parsedResponse.data);
        setConsDataDownload(parsedResponse.data);
        console.log(
          dayAndMileageRateResponse,
          "dayAndMileageRateResponsedayAndMileageRateResponse"
        );

        if (ConsolidatedInvoiceDetails && invoiceDetails) {
          const ConsolidatedInvoiceDetailsJson = JSON.parse(
            ConsolidatedInvoiceDetails
          );

          setConsDataDownload(ConsolidatedInvoiceDetailsJson);

          const invoiceDetailsJson = JSON.parse(invoiceDetails);

          console.log(invoiceDetailsJson, "invoiceDetailsJson");

          const sortingData = invoiceDetailsJson.sort((a, b) => {
            // Determine the correct key dynamically
            const keyA = a.PeriodKey || a.InvPeriodKey; 
            const keyB = b.PeriodKey || b.InvPeriodKey; 
          
            if (!keyA || !keyB) {
              return 0; // If either key is missing, do not change the order
            }
          
            // Extract the start date strings (Assuming MMDDYYYY format)
            const startDateStrA = keyA.substring(0, 8);
            const startDateStrB = keyB.substring(0, 8);
          
            // Convert to Date objects
            const startDateA = new Date(
              startDateStrA.substring(4, 8), // Year
              startDateStrA.substring(0, 2) - 1, // Month (0-based index)
              startDateStrA.substring(2, 4) // Day
            );
            const startDateB = new Date(
              startDateStrB.substring(4, 8),
              startDateStrB.substring(0, 2) - 1,
              startDateStrB.substring(2, 4)
            );
          
            // Compare the Date objects
            return startDateA - startDateB;
          });
          

          console.log(sortingData, "sortingDatasortingData");

          // Iterate over each object in invoiceDetailsJson
          // First, create groupedData using reduce only once, outside of the loop
          const groupedData = sortingData.reduce((acc, curr) => {
            // Determine periodKeyVal for consistency
            const periodKeyVal = curr.PeriodKey || curr.InvPeriodKey;
            curr.periodDate = periodKeyToDate(periodKeyVal);

            // Try to find the group for the current item
            let brokerGroup = acc.find(
              (item) =>
                item.ProjID === (curr.ProjID || curr.InvProjectID) && // Ensure ProjID matches
                item.PeriodKey === periodKeyVal // Ensure PeriodKey matches
            );

            // If no group found for the current item, create one
            if (!brokerGroup) {
              brokerGroup = {
                ProjectName: curr.ProjectName,
                ProjID: curr.ProjID || curr.InvProjectID,
                PeriodKey: curr.PeriodKey || curr.InvPeriodKey,
                periodDate: curr.periodDate,
                matchedDatas: [curr], // Add the current item to the group
              };
              acc.push(brokerGroup); // Add the new group to the accumulator
            } else {
              // Check if the current item already exists in the matchedDatas array
              // const isDuplicate = brokerGroup.matchedDatas.some(
              //   (data) => data.InvoiceDetailsID === curr.InvoiceDetailsID
              // );

              // // Only add the current item if it's not a duplicate
              // if (!isDuplicate) {
              brokerGroup.matchedDatas.push(curr);
              // }
            }

            return acc;
          }, []);

          console.log(groupedData, "groupedData");

          // Update matchedDatas for properly matched data only
          // invoiceDetailsJson.forEach((itemA) => {
          //   const periodKeyVal = itemA.PeriodKey
          //     ? itemA.PeriodKey
          //     : itemA.InvPeriodKey;
          //   itemA.periodDate = periodKeyToDate(periodKeyVal);

          //   // Find the matching group in groupedData
          //   const group = groupedData.find(
          //     (item) =>
          //       (item.ProjectName === itemA.ProjectName ||
          //         item.ProjID === itemA.ProjID) &&
          //       (item.PeriodKey === itemA.PeriodKey ||
          //         item.PeriodKey === itemA.InvPeriodKey)
          //   );

          //   if (group) {
          //     // Ensure no duplicates before adding to matchedDatas
          //     const exists = group.matchedDatas.some(
          //       (data) =>
          //         data.ProjectName === itemA.ProjectName &&
          //         data.PeriodKey === itemA.PeriodKey &&
          //         data.ProjID === itemA.ProjID
          //     );

          //     if (!exists) {
          //       group.matchedDatas.push(itemA);
          //     }
          //   }
          // });

          // console.log(groupedData, "groeupedddddddddddddddddd");

          // Initialize summedDataTotalOwned for aggregation
          let summedDataTotalOwned = 0;

          // Iterate through groupedData to calculate totals
          groupedData.forEach((group) => {
            const getBillableDayRate = (responseArray, group) => {
              if (!Array.isArray(responseArray)) return 0;

              const matchingResponse = responseArray.find(
                (item) =>
                  item?.projectId === group?.ProjID &&
                  item?.periodKey === group?.PeriodKey
              );

              return matchingResponse ? matchingResponse.dayRate || 0 : 0;
            };
            const getMileageRate = (responseArray, group) => {
              if (!Array.isArray(responseArray)) return 0;

              const matchingResponse = responseArray.find(
                (item) =>
                  item?.projectId === (group?.ProjID || group?.InvProjectID) &&
                  item?.periodKey === (group?.PeriodKey || group?.InvPeriodKey)
              );

              return matchingResponse ? matchingResponse.mileageRate || 0 : 0;
            };

            // Initialize summedData for each group
            const summedData = {
              BillableDayRate: getBillableDayRate(
                dayAndMileageRateResponse,
                group
              ),
              Hours: 0,
              Miles: 0,
              Lodging: 0,
              Copies: 0,
              Misc: 0,
              PerDiem: 0,
              MileageRate: 0,
              mileageRate: getMileageRate(dayAndMileageRateResponse, group),
            };
            const matchingRateHeader =
              (Array.isArray(dayAndMileageRateResponse)
                ? dayAndMileageRateResponse
                : []
              ).find(
                (item) =>
                  String(item?.projectId) === String(group?.ProjID) &&
                  String(item?.periodKey) === String(group?.PeriodKey)
              ) || {};
            summedData.BrokerChargeBreakdown = getPrintBrokerCharges(
              group.matchedDatas,
              matchingRateHeader
            );

            // Aggregate data within the group
            group.matchedDatas.forEach((item) => {
              summedData.Hours += item.Hours || 0;
              summedData.Miles += item.Miles || 0;
              summedData.Lodging += item.Lodging || 0;
              summedData.Copies += item.Copies || 0;
              summedData.Misc += item.Misc || 0;
              summedData.PerDiem += item.PerDiem || 0;
              summedData.MileageRate +=
                group.matchedDatas[0]?.MileageRate.toFixed(3) || 0;
            });
            console.log(
              summedData.Miles,
              "ouwqduiwyduyduqwyuid",
              group.matchedDatas[0]?.MileageRate,
              summedData.MileageRate
            );
            // Calculate totals for the group
            const totalPerDiem = summedData.PerDiem;
            const expenses =
              summedData.Lodging + summedData.Copies + summedData.Misc;
            const mileage =
              summedData.Miles *
              getMileageRate(dayAndMileageRateResponse, group);
             const charges = getBrokerChargeTotal(summedData.BrokerChargeBreakdown);

            console.log(
              totalPerDiem,
              expenses,
              "expensesexpensesexpenses",
              mileage,
              charges
            );

             // Total Owed uses the split broker charges shown on the page (one
            // line per day rate type) instead of billing every hour at the
            // billable rate.
            summedData.TotalOwned = getTotalOwed({
              brokerCharges: summedData.BrokerChargeBreakdown,
              perDiem: summedData.PerDiem,
              lodging: summedData.Lodging,
              copies: summedData.Copies,
              misc: summedData.Misc,
              miles: summedData.Miles,
              mileageRate: getMileageRate(dayAndMileageRateResponse, group),
            });
            console.log(summedData, "summedDatasummedData");
            // Update the total summedDataTotalOwned
            summedDataTotalOwned = summedData.TotalOwned;

            // Assign the calculated summedData back to the group for reference
            group.summedData = summedData;
          });

          // Log or utilize summedDataTotalOwned
          console.log("Total Owed Across All Groups:", summedDataTotalOwned);

          console.log(groupedData, "Final groupedData");

          console.log(
            "ConsolidatedInvoiceDetailsJson",
            ConsolidatedInvoiceDetailsJson
          );
          console.log("invoiceDetailsJson", invoiceDetailsJson);

          setConsolidateInvoiceData(groupedData);
          setInvoiceTotalOwned(summedDataTotalOwned.toFixed(2));
          // setInvoiceTotalStatic(i)
        }
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
      }
      return null; // Return null on error
    } finally {
      setLoading(false);
    }
  };

  const getDayAndMileageRateRecentData = async () => {
    let data = {
      invoiceId: invoiceId,
    };

    const config = {
      method: "GET",
      headers: authHeader(),
      url: GET_DAY_AND_MILEAGE_RATE_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        var uniqueProjectsMillageAndDayRate = [];

        if (
          parsedResponse.invoiceData &&
          parsedResponse.invoiceData.length > 0
        ) {
          parsedResponse.invoiceData.map(function (project) {
            var found = uniqueProjectsMillageAndDayRate.find(function (p) {
              return (
                p.projectId === project.projectId &&
                p.periodKey == project.periodKey
              );
            });

            if (!found) {
                uniqueProjectsMillageAndDayRate.push({
                  projectId: project.projectId,
                  dayRate: project.dayRate,
                  mileageRate: project.mileageRate,
                  periodKey: project?.periodKey,
                  selectedDayRate:
                    project.selectedDayRate ?? project.SelectedDayRate,
                  selectedPrincipalRate:
                    project.selectedPrincipalRate ?? project.SelectedPrincipalRate,
                  selectedProjectManagerRate:
                    project.selectedProjectManagerRate ??
                    project.SelectedProjectManagerRate,
                  selectedFieldAgentRate:
                    project.selectedFieldAgentRate ??
                    project.SelectedFieldAgentRate,
                });
            }
          });
          return uniqueProjectsMillageAndDayRate;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomerDetail = async (userId) => {
    let data = {
      userId: userId,
    };

    const config = {
      method: "GET",
      url: GET_CUSTOMER_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        return parsedResponse.data;
      } else {
        return null;
      }
    } catch (error) {}
  };

  const getAttachmentPDFApi = async (userId) => {
    let data = {
      invoiceId: invoiceId ? invoiceId : userId,
    };

    const config = {
      method: "GET",
      url: GET_INVOICE_PDF_ATTACHMENTS_API,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "lakjahgafafafagagag");
      if (parsedResponse.data && parsedResponse.data.length > 0) {
        setPreviewDetails(parsedResponse.data);
      } else {
        return null;
      }
    } catch (error) {}
  };

  const getProjectDetail = async (projectId) => {
    let data = {
      projectId: resultArray[0].ProjID,
    };

    const config = {
      method: "GET",
      url: GET_PROJECT_DETAILS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse && parsedResponse.ProjectDetails) {
        return parsedResponse.ProjectDetails;
      } else {
        return null;
      }
    } catch (error) {}
  };

  const handleChangeDownloadType = (event) => {
    var selectedValue = event.target.value;
    setLoading(true);
    setDownloadType(selectedValue);
    setFullPageView(true);
    setZoomPgae(0);

    setTimeout(() => {
      if (selectedValue === "DOC") {
        textFileDownloadSection();
        // downloadDocxWithImages();
      } else if (selectedValue === "IMAGE") {
        imageFileDownloadSection();
      } else if (selectedValue === "PDF") {
        setpdfViewer(true);
        setTimeout(async () => {
          try {
            await downloadAlllCombinedPDF();
          } catch (error) {
            console.error("Error downloading combined PDF:", error);
          } finally {
            setLoading(false);
          }
        }, 0);
      } else if (selectedValue === "EXCEL") {
        excelFileDownloadSection();
      }
    }, 1500);
  };

  const imageFileDownloadSection = async () => {
    const element = captureRef.current;

    if (element) {
      // Create a wrapper div for consistent padding
      const wrapper = document.createElement("div");
      wrapper.style.padding = "50px"; // Adjust padding as needed
      wrapper.style.backgroundColor = "white"; // Optional: to avoid transparency issues
      wrapper.style.boxSizing = "border-box"; // Ensure padding is included in dimensions

      // Clone the original element into the wrapper
      const clonedElement = element.cloneNode(true);
      wrapper.appendChild(clonedElement);

      // Append wrapper to the body temporarily for rendering
      document.body.appendChild(wrapper);
      const invoiceDate = new Date(invoiceData[0]?.InvoiceDate);
      const monthAbbr = invoiceDate.toLocaleString("en-US", { month: "short" }); // Get month abbreviation (e.g., "Feb")
      const year = invoiceDate.getFullYear(); // Get year (e.g., 2025)
      // Create a link element and trigger the download
      // Capture the wrapper using html2canvas
      const canvas = await html2canvas(wrapper);
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      // link.download = `${invoiceData[0]?.CustomerName}_HOS_${invoiceData[0]?.invoiceId}.png`;
      link.download = `HOS Invoice ${invoiceData[0]?.invoiceId} ${consolidateInvoiceData[0]?.ProjectName} ${invoiceData[0]?.earliestDate}.png`;
      link.click();

      // Remove the temporary wrapper from the DOM
      document.body.removeChild(wrapper);

      setFullPageView(false);
      setpdfViewer(false);
      setDownloadType("Save as");
      setLoading(false);
    }
    setLoading(false);
  };

  const textFileDownloadSection = () => {
    const emailTemplate = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice</title>
</head>
<body style="font-family: Arial, sans-serif; margin: 0; padding: 0; background-color: #f5f5f5;">

    <div style="width: 800px; margin: 20px auto; background-color: #fff; padding: 20px; border: 1px solid #ddd;">
        <!-- Header -->
          <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; margin-top: 10px;">
          <tr>
            <td style="text-align: left; padding-right: 10px; vertical-align: top;">
              <img src="https://hosv2dev.blob.core.windows.net/hosv2dev/HOS-logo_2024-11-29-05-45-04.png" alt="Logo" height="60px" width="50%"/>
            </td>
            <td style="text-align: right; padding-left: 10px; padding-right:10px;vertical-align: top;">
                <div style="display: flex; justify-content: space-between;">
                    <!-- Invoice No Box -->
                    <div style="border-right: 4px solid green; padding-right: 10px; margin-top: auto; margin-bottom: auto;">
                        <p style="margin: 0; font-weight: bold;">INVOICE NO:</p>
                        <p style="margin: 0; font-size: 18px;">
                            ${invoiceData[0] ? invoiceData[0].invoiceId : "--"}
                        </p>
                    </div>
                </div>
            </td>

            <td style="text-align: right; padding-left: 10px;padding-right: 10px; vertical-align: top;">
                <div style="display: flex; justify-content: space-between;">
                    
                    <!-- Total Due Box -->
                    <div style="border-right: 4px solid green; padding-right: 10px; margin-top: auto; margin-bottom: auto;">
                        <p style="margin: 0; font-weight: bold;">TOTAL DUE:</p>
                        <p style="margin: 0; font-size: 18px;">
                            $${
                              invoiceTotalStatic == invoiceTotalOwned
                                ? invoiceTotalOwned?.toFixed(2)
                                : invoiceData[0]?.InvoiceTotal?.toFixed(2)
                                ? invoiceData[0]?.InvoiceTotal?.toFixed(2)
                                : "0.00"
                            }
                        </p>
                    </div>
                </div>
            </td>
          </tr>
  </table>


  ${
    consolidateInvoiceData.length > 0 &&
    consolidateInvoiceData
      .filter((val) => val?.matchedDatas?.length > 0)
      .map((consolidateInvoiceDetail) => {
        const groupedDataTable = consolidateInvoiceDetail.matchedDatas.reduce(
          (acc, curr) => {
            const { BrokerID } = curr;
            if (!acc[BrokerID]) {
              acc[BrokerID] = [];
            }
            acc[BrokerID].push(curr);
            return acc;
          },
          {}
        );
        return `
      <table style="page-break-inside: avoid; border-collapse: collapse;width:100%;margin-bottom:20px;margin-top:15px;background-color:#f6f7f9;border-bottom:1px solid #E3E5E8">
          <tr>
              <th style="margin: 0; font-size: 14px; padding: 15px;padding-bottom:0px;text-align:left;">
                  Billing Period - ${
                    consolidateInvoiceDetail.periodDate
                      ? consolidateInvoiceDetail.periodDate
                      : "No billing statement available."
                  }
              </th>
          </tr>
      </table>
  
      <!-- Company Information -->
      <table style="page-break-inside: avoid; border-collapse: collapse;margin-top:0px;">
        <tr>
          <th style="text-align:left;">
              <p style="margin:0;font-size:15px;font-weight:700;line-height:19.6px;margin-bottom:10px;word-break:break-all;line-break: anywhere;">
                  ${invoiceData[0] ? invoiceData[0].CustomerName : ""}
              </p>
              <p style="line-break: anywhere;margin:0;font-size:13px;font-weight:400;word-break:break-all;line-height: 132%;">
                  ${
                    invoiceData[0].InvoiceBillToStreet1
                      ? invoiceData[0].InvoiceBillToStreet1 + ", "
                      : ""
                  }
                  ${
                    invoiceData[0].InvoiceBillToStreet2
                      ? invoiceData[0].InvoiceBillToStreet2 + ", "
                      : ""
                  }
                    </p>
                    <p>
                  ${
                    invoiceData[0].InvoiceBillToCity
                      ? invoiceData[0].InvoiceBillToCity + ", "
                      : ""
                  }
                  ${
                    invoiceData[0]?.InvoiceBillToState &&
                    matchingState?.Abbreviation
                      ? matchingState.Abbreviation + " "
                      : ""
                  }
                  ${invoiceData[0] ? invoiceData[0].InvoiceBillToZip : ""}
              </p>
             <p style="margin:0;font-size:12px;font-weight:400;line-height: 132%;">
                  PRINT DATE - ${currentPrintDate}
              </p>
          </th>
          <th style="font-size:15px;text-align:right;margin-bottom:auto;vertical-align:top;word-break:break-word;font-weight:700;">
                   <p style="margin:0;font-size:15px;font-weight:700;line-height:19.6px;margin-bottom:10px;word-break:break-all;line-break: anywhere;"><b>${
                     consolidateInvoiceDetail
                       ? consolidateInvoiceDetail.ProjectName
                       : ""
                   }</b></p>
              <p style="line-break: anywhere;margin:0;font-size:13px;word-break:break-all;font-weight:400;line-height: 132%;">
                  Project #${
                    consolidateInvoiceDetail
                      ? consolidateInvoiceDetail.ProjID
                      : ""
                  }
              </p>
          </th>
          </tr>
      </table>
        <table>
        <tr><td></td></tr>
        </table>
      <!-- Summary Table -->
      <table style="page-break-inside: avoid; border-collapse: collapse;width:100%;margin-top:-20px;background-color:#f2f2f2;margin-bottom:10px;border-collapse:collapse;">
          <tr>
              <th style="padding:0px 10px;font-size:12px;font-weight:500;border-right:10px solid #fff;margin-top:10px;">
                  Total Hours<br>
                  <span style="font-size:12px;font-weight:400;color:#667085">sum of all hours</span><br>
                  <span style="font-weight:600;font-size:14px;line-height:19.6px;color:#333843;">
                      ${
                        consolidateInvoiceDetail &&
                        consolidateInvoiceDetail.summedData
                          ? consolidateInvoiceDetail.summedData.Hours.toFixed(2)
                          : "0.00"
                      }
                  </span>
              </th>
              <th style="padding:0px 10px;font-size:12px;font-weight:500;border-right:10px solid #fff;margin-top:10px;">
                  Broker Charges<br>
                  <span style="font-size:12px;font-weight:400;color:#667085">
                      ${(consolidateInvoiceDetail?.summedData?.BrokerChargeBreakdown || [])
                        .map(formatBrokerChargeLine)
                        .join("<br>")}
                  </span><br>
                  <span style="font-weight:600;font-size:14px;line-height:19.6px;color:#333843;">
                      $ ${getBrokerChargeTotal(
                        consolidateInvoiceDetail?.summedData?.BrokerChargeBreakdown
                      ).toFixed(2)}
                  </span>
              </th>
              <th style="padding:0px 10px;font-size:12px;font-weight:500;border-right:10px solid #fff;margin-top:10px;">
                  Per Diem<br>
                  <span style="font-size:12px;font-weight:400;color:#667085">total per diem</span><br>
                  <span style="font-weight:600;font-size:14px;line-height:19.6px;color:#333843;">
                      $ ${
                        consolidateInvoiceDetail &&
                        consolidateInvoiceDetail.summedData
                          ? consolidateInvoiceDetail.summedData.PerDiem.toFixed(
                              2
                            )
                          : "0.00"
                      }
                  </span>
              </th>
          </tr>
           <tr>
     <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Expenses<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">lodging, copies & misc</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">$ ${
          consolidateInvoiceDetail && consolidateInvoiceDetail.summedData
            ? (
                consolidateInvoiceDetail.summedData.Lodging +
                consolidateInvoiceDetail.summedData.Copies +
                consolidateInvoiceDetail.summedData.Misc
              ).toFixed(2)
            : "0.00"
        }</span>
        </th>
        <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Miles<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">${
          consolidateInvoiceDetail && consolidateInvoiceDetail.summedData
            ? consolidateInvoiceDetail.summedData.Miles.toFixed(2)
            : "0.00"
        } miles * $ ${
          consolidateInvoiceDetail &&
          consolidateInvoiceDetail?.summedData?.mileageRate
            ? consolidateInvoiceDetail?.summedData?.mileageRate.toFixed(3)
            : "0.000"
        } / mile</span><br>
         <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;"> $
                                      ${
                                        invoiceData[0]
                                          ? (
                                              (consolidateInvoiceDetail &&
                                              consolidateInvoiceDetail.summedData
                                                ? consolidateInvoiceDetail
                                                    .summedData.Miles
                                                : 0) *
                                              (consolidateInvoiceDetail &&
                                              consolidateInvoiceDetail
                                                ?.summedData?.mileageRate
                                                ? consolidateInvoiceDetail?.summedData?.mileageRate.toFixed(
                                                    3
                                                  )
                                                : 0)
                                            ).toFixed(3)
                                          : "0.000"
                                      }</span>
        </th>
        <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Total Owed<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">total owed to broker</span><br>
         <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">
        $ ${
          consolidateInvoiceDetail && consolidateInvoiceDetail.summedData
            ? consolidateInvoiceDetail.summedData.TotalOwned.toFixed(2)
            : "0.00"
        }</span>
        </th>
    </tr>
      </table>
      <br>
  
      <!-- Details Table -->
${Object.entries(groupedDataTable)
  .map(([brokerId, invoiceDetail]) => {
    const brokerName = invoiceDetail[0]?.BrokerName || "Unknown";
    const totalHours = invoiceDetail.reduce(
      (sum, row) => sum + (row.Hours || 0),
      0
    );
    const totalMiles = invoiceDetail.reduce(
      (sum, row) => sum + (row.Miles || 0),
      0
    );
    const totalLodging = invoiceDetail.reduce(
      (sum, row) => sum + (row.Lodging || 0),
      0
    );
    const totalCopies = invoiceDetail.reduce(
      (sum, row) => sum + (row.Copies || 0),
      0
    );
    const totalMisc = invoiceDetail.reduce(
      (sum, row) => sum + (row.Misc || 0),
      0
    );
    const totalPerDiem = invoiceDetail.reduce(
      (sum, row) => sum + (row.PerDiem || 0),
      0
    );

    // Corrected section - Avoid double .join()
    return `
     <table style="page-break-inside: avoid; border-collapse: collapse;margin-bottom: 10px !important;padding-left:0px;margin-left:-5px;">
        <tr>
        <td style="padding-top:13px;text-align:left;color: #333843;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
    letter-spacing: 0.075px;
    margin-bottom: 9px;
    word-break: break-word;
    text-transform: uppercase;padding-left:0px;">Broker: ${brokerName} </td>
        </tr>
        </table>
        <table style="page-break-inside: avoid; border-collapse: collapse;width:100%;border-collapse:collapse;margin-bottom:20px;margin-top:10px !important;">
            <thead style="background-color:#4CAF50;color:#fff;">
                <tr>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Date</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Day Rate Type</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Type</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Hours</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Miles</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Lodging</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Copies</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;">Misc</th>
                    <th style="padding:0px 8px;padding-top:13px;text-align:left;min-width: 54px;">Per Diem</th>
                </tr>
            </thead>
            <tbody>
                ${invoiceDetail
                  .filter((item) => item?.BillingType != 0)
                  .sort((a, b) => {
                    // Convert the date fields to Date objects for comparison
                    const dateA = new Date(a.Date); // Replace `a.Date` with the actual date field name
                    const dateB = new Date(b.Date); // Replace `b.Date` with the actual date field name

                    // Sort in ascending order (oldest to newest)
                    return dateA - dateB;
                  })
                  .map(
                    (invoiceDataRow) => `
                    <tr style="border-bottom:1px solid #ededed;">
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            ${invoiceDataRow.Date}<br>
                            <span style="color:#667085;font-size:12px;font-style:normal;font-weight:400;letter-spacing:0.06px;word-break:break-word;">
                                ${
                                  invoiceDataRow.Description || "No Description"
                                }
                            </span>
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            ${getPrintDayRateType(invoiceDataRow)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            ${
                              billTypeList.find(
                                (row) => row.id === invoiceDataRow.BillingType
                              )?.name || "Unknown"
                            }
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            ${invoiceDataRow.Hours.toFixed(2)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            ${invoiceDataRow.Miles.toFixed(2)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            $${invoiceDataRow.Lodging.toFixed(2)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            $${invoiceDataRow.Copies.toFixed(2)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            $${invoiceDataRow.Misc.toFixed(2)}
                        </td>
                        <td style="padding:8px;padding-bottom: 0px;text-align: left;border-bottom: 1px solid #ededed;">
                            $${invoiceDataRow.PerDiem.toFixed(2)}
                        </td>
                    </tr>
                `
                  )
                  .join("")} <!-- Single .join() -->
                <tr>
                    <td style="padding: 10px;text-align: left;font-weight:700;">Total</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;"></td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">${totalHours?.toFixed(
                      2
                    )}</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">${totalMiles?.toFixed(
                      2
                    )}</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">$${totalLodging?.toFixed(
                      2
                    )}</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">$${totalCopies?.toFixed(
                      2
                    )}</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">$${totalMisc?.toFixed(
                      2
                    )}</td>
                    <td style="padding: 10px;text-align: left;font-weight:700;">$${totalPerDiem?.toFixed(
                      2
                    )}</td>
                </tr>
            </tbody>
        </table>
    `;
  })
  .join("")} <!-- Single .join() at the end -->
    `;
      })
      .join("")
  }          

        <!-- Footer -->
        <br />

  <div style="margin-top: 40px; color: #000; text-align: center; font-size: 12px;font-style: normal;
font-weight: 400;line-height: 132%; /* 13.2px */letter-spacing: 0.05px">
          <p>&copy; 2018 HOS Resources, LLC. All Rights Reserved.
          910 Harding Street, Lafayette, LA 70503.
          337.889.3941 | <a href="https://hosresources.com/" target="_blank">www.hosresources.com</a>
          </p>
  </div>

  <br />
        <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; background-color: #4CAF50; color: white; padding: 10px; border-radius: 5px; border-collapse: collapse;">
          <tr>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">910 Harding Street<b/>Lafayette, LA 70503</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">P.O. Box 51794<b/> Lafayette, LA 70505</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">337.889.3941</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;color: #FFF; font-size: 12px;font-style: normal;
font-weight: 400; line-height: normal;">www.hosresources.com</p>
            </td>
          </tr>
        </table>
    </div>

</body>
</html>`;

    // Convert the HTML to a DOCX blob
    const converted = htmlDocx.asBlob(emailTemplate);
    const invoiceDate = new Date(invoiceData[0]?.InvoiceDate);
    const monthAbbr = invoiceDate.toLocaleString("en-US", { month: "short" }); // Get month abbreviation (e.g., "Feb")
    const year = invoiceDate.getFullYear(); // Get year (e.g., 2025)
    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(converted);
    // link.download = `${invoiceData[0]?.CustomerName}_HOS_${invoiceData[0]?.invoiceId}.docx`; // Specify the file name
    link.download = `HOS Invoice ${invoiceData[0]?.invoiceId} ${consolidateInvoiceData[0]?.ProjectName} ${invoiceData[0]?.earliestDate}.docx`;

    // Programmatically click the link to trigger the download
    link.click();
    setFullPageView(false);
    setpdfViewer(false);
    setDownloadType("Save as");
    setLoading(false);
  };

  const downloadAlllCombinedPDF = async () => {
    try {
      const pageWidth = 595.276; // A4 width in points
      const pageHeight = 841.89; // A4 height in points
      const margin = 25; // Margin for all sides
      const pdfDoc = await PDFDocument.create();

      // Step 1: Capture the preview content as an image
      const capturediv = document.getElementById("capturediv");
      capturediv.style.width = "100%"; // Let it take full width

      console.log(pdfDoc, "pdfDocpdfDoc");

      const canvas = await html2canvas(capturediv, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL("image/png");
      const imgBuffer = await fetch(imgData).then((res) => res.arrayBuffer());
      const img = await pdfDoc.embedPng(imgBuffer);

      const imgWidth = pageWidth - 2 * margin; // Full width minus left and right margins
      const imgWidth1 = pageWidth - margin; // Full width minus left and right margins
      const imgHeight = (canvas.height * imgWidth1) / canvas.width; // Calculate scaled height for the image

      // Step 2: Calculate scaling to fit the A4 page width and height with margins
      const widthScale = pageWidth; // Full width minus margins
      const heightScale = pageHeight - 2 * margin; // Height with top and bottom margins
      const scale = Math.min(widthScale / imgWidth, heightScale / imgHeight); // Scaling to fit A4 with margins

      const scaledWidth = imgWidth - 5;
      const scaledHeight = imgHeight * scale;

      // Step 3: Add multiple pages if the content exceeds a single page height
      let heightCovered = 0;
      const fullPages = Math.floor(imgHeight / (pageHeight - 2 * 10)); // Number of full pages
      let contentAdded = false;
      // Render the content page by page
      for (let i = 0; i <= fullPages; i++) {
        const startY = (heightCovered * canvas.width) / imgWidth; // Calculate the Y offset for the current part of the image
        const partHeight = Math.min(
          pageHeight - 2 * 30,
          imgHeight - heightCovered
        ); // Height of the current part of the image to render

        // Create a temporary canvas for the current part
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = canvas.width;
        tempCanvas.height = (partHeight * canvas.width) / imgWidth; // Scale the height based on the image width
        const tempCtx = tempCanvas.getContext("2d");

        // Draw the current part onto the temporary canvas
        tempCtx.drawImage(canvas, 0, -startY);

        // Convert the temporary canvas to a data URL (PNG)
        const partImgData = tempCanvas.toDataURL("image/png");

        // Embed the image into the PDF
        const partImgBuffer = await fetch(partImgData).then((res) =>
          res.arrayBuffer()
        );
        const partImg = await pdfDoc.embedPng(partImgBuffer);

        // Add a new page for the first part of the image
        if (!contentAdded) {
          pdfDoc.addPage([pageWidth, pageHeight]); // Add the first page
          contentAdded = true;
        }
        // Get the current page to draw the image on
        const currentPage = pdfDoc.getPages()[i];

        // Draw the image on the current page with margins applied to both sides
        currentPage.drawImage(partImg, {
          x: margin, // Left margin
          y: pageHeight - 20 - partHeight,
          width: scaledWidth, // Scaled image width
          height: partHeight, // Scaled image height
        });

        heightCovered += partHeight; // Update the height covered so far

        console.log(i, "iiiiiiiiiiiiiiiiiiii", fullPages);

        // Add a new page if there is more content
        if (i < fullPages) {
          pdfDoc.addPage([pageWidth, pageHeight]);
        }
      }

      let filePageAdded = false; // Step 4: Combine attachments into the PDF
      for (const file of previewDetails) {
        const response = await fetch(file.filePath);
        if (!response.ok) {
          console.error(`Failed to fetch file: ${file.filePath}`);
          continue;
        }
        const blob = await response.blob();

        if (file.fileName.endsWith(".pdf") || file.fileName.endsWith(".PDF")) {
          const pdfBuffer = await blob.arrayBuffer();
          const externalPdf = await PDFDocument.load(pdfBuffer);
          const copiedPages = await pdfDoc.copyPages(
            externalPdf,
            externalPdf.getPageIndices()
          );

          // Calculate the title space
          const titleHeight = 20; // Adjust this to set the space for the title (file name)

          if (!filePageAdded) {
            filePageAdded = true; // Prevent adding unnecessary blank pages between different file types
          }

          await Promise.all(
            copiedPages.map(async (page, index) => {
              const newPage = pdfDoc.addPage(page);

              // Add the PDF file name as a title only to the first page
              if (index === 0) {
                await newPage.drawText(file.fileName, {
                  x: margin,
                  y: pageHeight - titleHeight, // Position at the top of the page
                  size: 12,
                  color: rgb(0, 0, 0), // Black color
                  font: await pdfDoc.embedFont(StandardFonts.Helvetica),
                });
              }

              // Adjust content position (leave space below the title)
              const contentYPosition = pageHeight - titleHeight - 10; // Add more space if needed

              // Now you can draw your content starting from this position
              // For example, if you want to add text content on the page
              // await newPage.drawText('Your content goes here', { x: 0, y: contentYPosition, size: 10 });
            })
          );
        } else if (
          file.fileName.endsWith(".png") ||
          file.fileName.endsWith(".PNG") ||
          file.fileName.endsWith(".jpg") ||
          file.fileName.endsWith(".JPG") ||
          file.fileName.endsWith(".jpeg") ||
          file.fileName.endsWith(".JPEG") ||
          file.fileName.endsWith(".webp") ||
          file.fileName.endsWith(".WEBP") ||
          file.fileName.endsWith(".svg") ||
          file.fileName.endsWith(".SVG")
        ) {
          try {
            const imageBuffer = await blob.arrayBuffer();
            let image;

            // Embed the image depending on the file type
            if (
              file.fileName.endsWith(".png") ||
              file.fileName.endsWith(".PNG")
            ) {
              image = await pdfDoc.embedPng(imageBuffer);
            } else if (
              file.fileName.endsWith(".jpg") ||
              file.fileName.endsWith(".jpeg") ||
              file.fileName.endsWith(".JPG") ||
              file.fileName.endsWith(".JPEG")
            ) {
              image = await pdfDoc.embedJpg(imageBuffer);
            } else if (
              file.fileName.endsWith(".webp") ||
              file.fileName.endsWith(".WEBP")
            ) {
              // Convert WebP image to PNG before embedding
              const webpImage = new Image();
              const objectURL = URL.createObjectURL(new Blob([imageBuffer]));
              webpImage.src = objectURL;

              // Wait for the image to load and decode
              await new Promise((resolve, reject) => {
                webpImage.onload = resolve;
                webpImage.onerror = reject;
              });

              // Create a canvas to draw the image
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = webpImage.width;
              canvas.height = webpImage.height;

              // Draw the WebP image onto the canvas
              ctx.drawImage(webpImage, 0, 0);

              // Convert the canvas content to PNG
              const imageData = canvas.toDataURL("image/png"); // Converts to PNG format

              // Fetch the image data as ArrayBuffer
              const imageBytes = await fetch(imageData).then((res) =>
                res.arrayBuffer()
              );

              // Embed the PNG image
              image = await pdfDoc.embedPng(imageBytes);
            } else if (
              file.fileName.endsWith(".svg") ||
              file.fileName.endsWith(".SVG")
            ) {
              try {
                // Convert SVG to PNG using a canvas
                const svgText = await blob.text(); // Read the SVG file as text
                const svgImage = new Image();

                // Create a Blob URL for the SVG text
                const svgBlob = new Blob([svgText], { type: "image/svg+xml" });
                const svgURL = URL.createObjectURL(svgBlob);
                svgImage.src = svgURL;

                // Wait for the image to load
                await new Promise((resolve, reject) => {
                  svgImage.onload = resolve;
                  svgImage.onerror = reject;
                });

                // Draw the SVG image onto a canvas
                const canvas = document.createElement("canvas");
                canvas.width = svgImage.width || 1000; // Default width if not specified in SVG
                canvas.height = svgImage.height || 1000; // Default height if not specified in SVG
                const ctx = canvas.getContext("2d");
                ctx.drawImage(svgImage, 0, 0);

                // Convert the canvas content to PNG
                const pngDataURL = canvas.toDataURL("image/png");
                const pngResponse = await fetch(pngDataURL);
                const pngBuffer = await pngResponse.arrayBuffer();

                // Embed the converted PNG image
                const image = await pdfDoc.embedPng(pngBuffer);

                const imageWidth = image.width;
                const imageHeight = image.height;

                // Scale the image to fit A4 size while maintaining aspect ratio
                const scale = Math.min(
                  (pageWidth - 2 * margin) / imageWidth,
                  (pageHeight - 2 * margin) / imageHeight
                );

                const scaledWidth = imageWidth * scale;
                const scaledHeight = imageHeight * scale;

                // Create a new page in the PDF for the SVG image
                const page = pdfDoc.addPage([pageWidth, pageHeight]);

                // Embed font for filename
                const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
                const fontSize = 12;

                // Draw the file name at the top
                page.drawText(file.fileName, {
                  x: margin,
                  y: pageHeight - margin - fontSize,
                  size: fontSize,
                  font,
                  color: rgb(0, 0, 0),
                });

                // Adjust the vertical position for the image (below the filename)
                const imageYPosition =
                  pageHeight - scaledHeight - margin - fontSize - 10;

                // Draw the image on the page
                page.drawImage(image, {
                  x: (pageWidth - scaledWidth) / 2, // Center horizontally
                  y: imageYPosition, // Position vertically below the filename
                  width: scaledWidth,
                  height: scaledHeight,
                });

                // Revoke the object URL to release memory
                URL.revokeObjectURL(svgURL);
              } catch (error) {
                console.error("Error processing SVG file:", error);
              }
            }

            const imageWidth = image.width;
            const imageHeight = image.height;

            // Scale the image to fit A4 size while maintaining aspect ratio
            const scale = Math.min(
              (pageWidth - 2 * margin) / imageWidth,
              (pageHeight - 2 * margin) / imageHeight
            );

            const scaledWidth = imageWidth * scale;
            const scaledHeight = imageHeight * scale;

            // Create a new page in the PDF for the image
            const page = pdfDoc.addPage([pageWidth, pageHeight]);

            // Embed font for filename
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
            const fontSize = 12;

            // Draw the file name at the top
            page.drawText(file.fileName, {
              x: margin,
              y: pageHeight - margin - fontSize,
              size: fontSize,
              font,
              color: rgb(0, 0, 0),
            });

            // Adjust the vertical position for the image (below the filename)
            const imageYPosition =
              pageHeight - scaledHeight - margin - fontSize - 10;

            // Draw the image on the page
            page.drawImage(image, {
              x: (pageWidth - scaledWidth) / 2, // Center horizontally
              y: imageYPosition, // Position vertically below the filename
              width: scaledWidth,
              height: scaledHeight,
            });
          } catch (error) {
            console.error("Error processing image file:", error);
          }
        }
      }
      const invoiceDate = new Date(invoiceData[0]?.InvoiceDate);
      const monthAbbr = invoiceDate.toLocaleString("en-US", { month: "short" }); // Get month abbreviation (e.g., "Feb")
      const year = invoiceDate.getFullYear();
      // Step 5: Save the final combined PDF
      const mergedPdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(pdfBlob);
      // link.download = `HOS Invoice ${invoiceData[0]?.invoiceId}_HOS_${invoiceData[0]?.invoiceId}.pdf`;
      link.download = `HOS Invoice ${invoiceData[0]?.invoiceId} ${consolidateInvoiceData[0]?.ProjectName} ${invoiceData[0]?.earliestDate}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Reset states
      setFullPageView(false);
      setDownloadType("Save as");
      setLoading(false);
    } catch (error) {
      console.error("Error combining files into PDF:", error);
      alert("An error occurred while processing the files.");
      setFullPageView(false);
      setDownloadType("Save as");
      setLoading(false);
    }
  };

  // Helper function to convert ArrayBuffer to base64 string
  function arrayBufferToBase64(buffer) {
    const binary = String.fromCharCode.apply(null, new Uint8Array(buffer));
    return window.btoa(binary);
  }

  // async function pdfFileDownloadSection() {
  //   // Get the HTML content
  //   const emailContent = document.getElementById("capturediv");

  //   // Use html2canvas to create a canvas from the HTML content
  //   const canvas = await html2canvas(emailContent, { scale: 2, useCORS: true }); // Added useCORS for external images
  //   const imgData = canvas.toDataURL("image/png");

  //   // Create a new jsPDF instance
  //   const pdf = new jsPDF("p", "mm", "a4");

  //   // Page dimensions
  //   const padding = 10; // Padding for all sides
  //   const pageWidth = pdf.internal.pageSize.width - padding * 2; // Width with padding
  //   const pageHeight = pdf.internal.pageSize.height - padding * 2; // Height with padding

  //   // Calculate the image dimensions
  //   const imgWidth = pageWidth;
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //   // Number of full pages
  //   const fullPages = Math.floor(imgHeight / pageHeight);

  //   // Render the content page by page
  //   let heightCovered = 0; // Keep track of height already rendered
  //   for (let i = 0; i <= fullPages; i++) {
  //     const startY = (heightCovered * canvas.width) / imgWidth; // Calculate the start height on the canvas
  //     const partHeight = Math.min(pageHeight, imgHeight - heightCovered); // Height of the part to render

  //     // Create a temporary canvas for the current part
  //     const tempCanvas = document.createElement("canvas");
  //     tempCanvas.width = canvas.width;
  //     tempCanvas.height = (partHeight * canvas.width) / imgWidth;
  //     const tempCtx = tempCanvas.getContext("2d");

  //     // Draw the current part onto the temporary canvas
  //     tempCtx.drawImage(canvas, 0, -startY);

  //     // Convert the temporary canvas to a data URL
  //     const partImgData = tempCanvas.toDataURL("image/png");

  //     // Add the image to the PDF
  //     pdf.addImage(partImgData, "PNG", padding, padding, imgWidth, partHeight);

  //     heightCovered += partHeight;

  //     // Add a new page if there is more content
  //     if (i < fullPages) {
  //       pdf.addPage();
  //     }
  //   }

  //   // Save the PDF
  //   pdf.save(
  //     `${invoiceData[0]?.CustomerName}_HOS_${invoiceData[0]?.invoiceId}.pdf`
  //   );

  //   setFullPageView(false);
  //   setpdfViewer(false);
  //   setDownloadType("Save as");
  //   setLoading(false);
  // }

  const excelFileDownloadSection = () => {
    handleExport();
  };

  const handlePrintContent = () => {
    let printContents = document.getElementById("capturediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    setFullPageView(false);
    setDownloadType("Save as");
    setpdfViewer(false);
  };

  // const handlePrint = async () => {
  //   setLoading(true)
  //   try {
  //     // pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.min.js';
  //     pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.worker.min.mjs';

  //     //     // Step 1: Create a unique and isolated container
  //     let printContainer = document.getElementById("print-container");
  //     if (!printContainer) {
  //       printContainer = document.createElement("div");
  //       printContainer.id = "print-container";
  //       document.body.appendChild(printContainer);
  //     }

  //     // Clear the container before adding new content
  //     printContainer.innerHTML = "";

  //     // Step 2: Add the `capturediv` content as an image
  //     const capturediv = document.getElementById("capturediv");
  //     const captureCanvas = await html2canvas(capturediv, { scale: 2, useCORS: true,   windowWidth: capturediv.scrollWidth,
  //       windowHeight: capturediv.scrollHeight, });
  //     const captureImg = captureCanvas.toDataURL("image/png");

  //     const captureImgElement = document.createElement("img");
  //     captureImgElement.src = captureImg;
  //     captureImgElement.style.width = "100%";
  //     captureImgElement.style.marginBottom = "20px";
  //     printContainer.appendChild(captureImgElement);

  //     // Step 3: Add attachments to the container
  //     for (const file of previewDetails) {
  //       const response = await fetch(file.filePath);
  //       if (!response.ok) {
  //         console.error(`Failed to fetch file: ${file.filePath}`);
  //         continue;
  //       }
  //       const blob = await response.blob();

  //       if (file.fileName.endsWith(".png") || file.fileName.endsWith(".jpg") || file.fileName.endsWith(".jpeg") || file.fileName.endsWith(".webp")) {
  //         const imageUrl = URL.createObjectURL(blob);
  //         const imgElement = document.createElement("img");
  //         imgElement.src = imageUrl;
  //         imgElement.style.width = "100%";
  //         imgElement.style.marginBottom = "20px";

  //         // Add the image to the print container
  //         printContainer.appendChild(imgElement);

  //         // Add a page break to ensure each image starts on a new page
  //         const pageBreak = document.createElement("div");
  //         pageBreak.style.pageBreakAfter = "always"; // Force a new page after this element
  //         printContainer.appendChild(pageBreak);
  //         // const imageUrl = URL.createObjectURL(blob);
  //         // const imgElement = document.createElement("img");
  //         // imgElement.src = imageUrl;
  //         // imgElement.style.width = "100%";
  //         // imgElement.style.marginBottom = "20px";
  //         // printContainer.appendChild(imgElement);
  //       }else if (file.fileName.endsWith(".pdf")) {
  //         try {
  //           const pdfBuffer = await blob.arrayBuffer();

  //           // Use pdf.js to load the PDF
  //           const loadingTask = pdfjsLib.getDocument({ data: pdfBuffer });
  //           const pdfDoc = await loadingTask.promise;

  //           const numPages = pdfDoc.numPages;

  //           // Render each PDF page using pdf.js
  //           for (let i = 1; i <= numPages; i++) {
  //             const page = await pdfDoc.getPage(i);
  //             const viewport = page.getViewport({ scale: 1 });

  //             // Create a new canvas for each page
  //             const canvas = document.createElement('canvas');
  //             canvas.width = viewport.width;
  //             canvas.height = viewport.height;

  //             const context = canvas.getContext('2d');

  //             const renderContext = {
  //               canvasContext: context,
  //               viewport: viewport,
  //             };

  //             // Render the page onto the canvas
  //             await page.render(renderContext).promise;

  //             // Convert the canvas to an image (PNG)
  //             const imgElement = document.createElement("img");
  //             imgElement.src = canvas.toDataURL('image/png');
  //             imgElement.style.width = "100%";
  //             imgElement.style.marginBottom = "20px";
  //             printContainer.appendChild(imgElement);
  //           }
  //         }catch (error) {
  //           setFullPageView(false);
  //           setDownloadType("Save as");
  //           setLoading(false)
  //           console.error("Error processing PDF file:", error);
  //           alert("An error occurred while processing the PDF.");
  //         }
  //       }

  //     }

  //     // Step 4: Apply print-specific styles
  //     const style = document.createElement("style");
  //     style.innerHTML = `
  //       @media print {
  //         body * {
  //           visibility: hidden;
  //         }
  //         #print-container, #print-container * {
  //           visibility: visible;
  //         }
  //         #print-container {
  //           position: absolute;
  //           left: 0;
  //           top: 0;
  //           width: 100%;
  //         }
  //       }
  //     `;
  //     document.head.appendChild(style);

  //     // Step 5: Trigger the print dialog
  //     window.print();
  //     setFullPageView(false);
  //     setDownloadType("Save as");
  //     setLoading(false)

  //     // Cleanup: Remove the container and style after printing
  //     printContainer.remove();
  //     style.remove();
  //   } catch (error) {
  //     setFullPageView(false);
  //     setDownloadType("Save as");
  //     setLoading(false)
  //     console.error("Error preparing content for printing:", error);
  //     alert("An error occurred while preparing the print content.");
  //   }
  // };

  const handlePrint = async () => {
    setLoading(true);

    try {
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.worker.min.mjs";

      let printContainer = document.getElementById("print-container");
      if (!printContainer) {
        printContainer = document.createElement("div");
        printContainer.id = "print-container";
        document.body.appendChild(printContainer);
      }
      printContainer.innerHTML = ""; // Clear the container before adding new content

      // Step 1: Capture content from capturediv and split it into pages
      const capturediv = document.getElementById("capturediv");

      if (capturediv) {
        const captureCanvas = await html2canvas(capturediv, {
          scale: 2,
          useCORS: true,
          windowWidth: capturediv.scrollWidth,
          windowHeight: capturediv.scrollHeight,
        });

        // Get the height of a single page (based on A4 size)
        const pageHeight = 1122; // Example for A4 height in pixels at 96 DPI
        const imgHeight = captureCanvas.height;
        const imgWidth = captureCanvas.width;
        let currentY = 0;

        while (currentY < imgHeight) {
          const canvas = document.createElement("canvas");
          canvas.width = imgWidth;
          canvas.height = Math.min(pageHeight, imgHeight - currentY);

          const ctx = canvas.getContext("2d");
          ctx.drawImage(
            captureCanvas,
            0,
            currentY,
            imgWidth,
            canvas.height,
            0,
            0,
            imgWidth,
            canvas.height
          );

          const imgElement = document.createElement("img");
          imgElement.src = canvas.toDataURL("image/png");
          imgElement.style.width = "100%";
          imgElement.style.marginBottom = "20px";

          printContainer.appendChild(imgElement);
          currentY += pageHeight;
        }
      }

      // Step 2: Process previewDetails after capturing capturediv
      let processedFiles = 0;
      let totalPages = 0; // Track the total number of pages across all PDFs
      const totalFiles = previewDetails.length;

      previewDetails.forEach((file) => {
        if (file.fileName.endsWith(".pdf") || file.fileName.endsWith(".PDF")) {
          totalPages += 1; // Count the PDF file as one entry (even if it has multiple pages)
        } else {
          totalPages += 1; // Each image is a single file
        }
      });

      const checkAllFilesRendered = () => {
        console.log(
          processedFiles,
          "Processed Files",
          totalPages,
          "Total Pages"
        );
        if (processedFiles === totalPages) {
          setTimeout(() => {
            window.onafterprint = () => {
              setLoading(false);
              setFullPageView(false);
              setpdfViewer(false);
            };
            triggerPrint(printContainer);
          }, 100); // Small delay to ensure everything is rendered
        } else {
          setTimeout(checkAllFilesRendered, 100); // Check again after 100ms
        }
      };

      for (const file of previewDetails) {
        const response = await fetch(file.filePath);
        if (!response.ok) {
          console.error(`Failed to fetch file: ${file.filePath}`);
          processedFiles++;
          continue;
        }

        const blob = await response.blob();

        // Wrapper to keep fileName and file content together
        const fileWrapper = document.createElement("div");
        fileWrapper.style.display = "block";
        fileWrapper.style.pageBreakBefore = "always"; // Start each file on a new page
        fileWrapper.style.pageBreakInside = "avoid"; // Prevent splitting file content
        fileWrapper.style.pageBreakAfter = "always";

        const fileContainer = document.createElement("div");
        fileContainer.style.pageBreakInside = "avoid"; // Prevent splitting

        // const fileNameElement = document.createElement("div");
        // fileNameElement.textContent = file.fileName;
        // fileNameElement.style.fontWeight = "bold";
        // fileNameElement.style.marginBottom = "10px";
        // fileNameElement.style.textAlign = "center";
        // // fileNameElement.style.pageBreakAfter = "avoid"; // Start each file on a new page 1
        // // fileNameElement.style.pageBreakInside = "avoid"; // Prevent splitting 2
        // fileContainer.appendChild(fileNameElement);

        if (
          file.fileName.endsWith(".png") ||
          file.fileName.endsWith(".PNG") ||
          file.fileName.endsWith(".jpg") ||
          file.fileName.endsWith(".JPG") ||
          file.fileName.endsWith(".jpeg") ||
          file.fileName.endsWith(".JPEG") ||
          file.fileName.endsWith(".webp") ||
          file.fileName.endsWith(".WEBP") ||
          file.fileName.endsWith(".WEBP") ||
          file.fileName.endsWith(".svg") ||
          file.fileName.endsWith(".SVG")
        ) {
          const imageUrl = URL.createObjectURL(blob);
          const imgElement = document.createElement("img");
          imgElement.src = imageUrl;
          imgElement.style.width = "100%";
          imgElement.style.marginBottom = "10px";

          // fileWrapper.style.pageBreakBefore = "auto"; // Don't force page break before images

          // Ensure the image maintains its aspect ratio and does not stretch
          imgElement.style.maxWidth = "100%"; // Allow it to stretch horizontally but not overflow
          imgElement.style.maxHeight = "calc(100vh - 100px)"; // Limit the height to 100vh minus some margin
          imgElement.style.objectFit = "contain"; // Ensure the aspect ratio is maintained, without stretching

          fileContainer.appendChild(imgElement); // Add the file image

          imgElement.onload = () => {
            processedFiles++;
          };
        } else if (
          file.fileName.endsWith(".pdf") ||
          file.fileName.endsWith(".PDF")
        ) {
          const pdfBuffer = await blob.arrayBuffer();
          const loadingTask = pdfjsLib.getDocument({ data: pdfBuffer });
          const pdfDoc = await loadingTask.promise;

          for (let i = 1; i <= pdfDoc.numPages; i++) {
            const page = await pdfDoc.getPage(i);
            const viewport = page.getViewport({ scale: 1 });

            const canvas = document.createElement("canvas");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            const context = canvas.getContext("2d");
            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };

            await page.render(renderContext).promise;

            const imgElement = document.createElement("img");
            imgElement.src = canvas.toDataURL("image/png");
            imgElement.style.width = "100%";
            imgElement.style.marginBottom = "10px";
            fileContainer.appendChild(imgElement);
          }

          processedFiles++;
        }
        fileWrapper.appendChild(fileContainer); // Add content wrapper to the file wrapper
        printContainer.appendChild(fileWrapper); // Add file wrapper to the print container
      }

      checkAllFilesRendered();
    } catch (error) {
      setLoading(false);
      console.error("Error preparing content for printing:", error);
      alert("An error occurred while preparing the print content.");
    }
  };

  // Function to trigger the print dialog
  const triggerPrint = (printContainer) => {
    const style = document.createElement("style");
    style.innerHTML = `
      @media print {
        body * {
          visibility: hidden;
        }
        #print-container, #print-container * {
          visibility: visible;
        }
        #print-container {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
      }`;
    document.head.appendChild(style);

    // Trigger print dialog
    window.print();

    // Cleanup
    printContainer.remove();
    style.remove();
    setLoading(false);
    setFullPageView(false);
    setpdfViewer(false);
  };

  //Excel
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const wsData = workbook.addWorksheet("Report");

    // Configure the worksheet for A4 page layout
    wsData.pageSetup = {
      paperSize: 32, // A4 paper size
      orientation: "Portrait", // Portrait orientation
      fitToPage: true, // Scale content to fit on one page
      fitToWidth: 0, // Fit to one page width
      fitToHeight: 0, // Allow unlimited height
    };

    // Set fixed column widths and wrap text for columns A to AF
    for (let col = 1; col <= 32; col++) {
      // Columns A to AF
      wsData.getColumn(col).width = 15; // Set a fixed width for clarity
      wsData.getColumn(col).alignment = { wrapText: false, horizontal: "left" };
    }

    // Ensure header row cells have proper alignment and sufficient height
    wsData.getRow(1).eachCell({ includeEmpty: true }, (cell) => {
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: false,
      }; // Center align headers
    });
    wsData.getRow(1).height = 30; // Set a reasonable header row height // Set a reasonable header row height

    // Set worksheet view options
    wsData.views = [
      {
        state: "normal",
        showGridLines: false,
      },
    ];

    try {
      try {
        const imageUrl =
          "https://hosv2dev.blob.core.windows.net/hosv2dev/HOS-logo_2024-11-29-05-45-04.png?sp=r&st=2024-11-29T19:32:35Z&se=2026-12-31T03:32:35Z&spr=https&sv=2022-11-02&sr=b&sig=vcGmp6ViPLUn73RgVtVmz1NHryyo1uBDmk0ttKqByas%3D";
        console.log("Fetching image from:", imageUrl);
        const response = await fetch(imageUrl, { method: "GET" });
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const imageBuffer = await response.arrayBuffer();

        // Add the image to the workbook
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: "png",
        });

        // Add the image to the worksheet
        wsData.addImage(imageId, {
          tl: { col: 0, row: 0 },
          ext: { width: 330, height: 80 }, // Dimensions of the image
        });

        // Add a row with formatted cells in one step.
        const row = wsData.addRow([
          null, // Leave the first column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          {
            richText: [
              { text: "INVOICE NO: ", font: { bold: false } },
              { text: `${invoiceData[0].invoiceId}`, font: { bold: true } },
            ],
          },
          null,
          {
            richText: [
              { text: "TOTAL DUE: ", font: { bold: false } },
              {
                text: `$${
                  invoiceTotalOwned == invoiceTotalStatic
                    ? invoiceTotalOwned?.toFixed(2)
                    : invoiceData[0]?.InvoiceTotal?.toFixed(2)
                    ? invoiceData[0]?.InvoiceTotal?.toFixed(2)
                    : "0.00"
                }`,
                font: { bold: true },
              },
            ],
          },
        ]);

        // Adjust column widths for proper alignment
        wsData.getColumn(1).width = 12; // Image column
        wsData.getColumn(2).width = 25; // Invoice column
        wsData.getColumn(3).width = 25; // Total due column
      } catch (error) {
        console.error("Error fetching or adding image:", error);
        return; // Exit if image addition fails
      }

      // Header Section
      wsData.addRow([]);
      wsData.addRow([]);

      if (consolidateInvoiceData && consolidateInvoiceData.length > 0) {
        consolidateInvoiceData.forEach((consolidateInvoiceDetail) => {
          const groupedDataTable = consolidateInvoiceDetail.matchedDatas.reduce(
            (acc, curr) => {
              const { BrokerID } = curr;
              if (!acc[BrokerID]) {
                acc[BrokerID] = [];
              }
              acc[BrokerID].push(curr);
              return acc;
            },
            {}
          );

          function addStyledCell2(
            row,
            startColumn,
            content,
            mergeColumns = 2,
            gapColumns = 1
          ) {
            const endColumn = startColumn + mergeColumns - 1;

            // Merge cells for the object.
            wsData.mergeCells(row.number, startColumn, row.number, endColumn);

            // Get the first cell in the merged range to apply styling.
            const cell = row.getCell(startColumn);
            cell.value = { richText: content };
            cell.alignment = {
              wrapText: true,
              vertical: "start",
              horizontal: "left",
            };

            // Apply background color to the merged range.
            for (let col = startColumn; col <= endColumn; col++) {
              const currentCell = row.getCell(col);
              currentCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6F7F9" },
              }; // Gray background
            }

            return startColumn + mergeColumns + gapColumns; // Return next start column.
          }

          // Create a new row and apply the styled cell function.
          const row4 = wsData.addRow([]);
          row4.height = 20;
          let startColumn4 = 1;

          // Add a cell that spans 7 columns and has a background color.
          startColumn4 = addStyledCell2(
            row4,
            startColumn4,
            [
              {
                text: `Billing Period: ${consolidateInvoiceDetail.periodDate}\n`,
                font: { bold: true },
              },
            ],
            8
          );

          wsData.addRow([]);

          // Function to add a styled cell with optional merging and content.
          function addStyledCell1(
            row,
            startColumn,
            content,
            mergeColumns = 2,
            gapColumns = 1
          ) {
            const endColumn = startColumn + mergeColumns - 1;

            // Merge cells for the object.
            wsData.mergeCells(row.number, startColumn, row.number, endColumn);

            const cell = row.getCell(startColumn);
            cell.value = { richText: content };
            cell.alignment = {
              wrapText: true,
              vertical: "start",
              horizontal: "center",
            };

            return startColumn + mergeColumns + gapColumns; // Return the next start column.
          }

          // Add a new row with the required height.
          const row3 = wsData.addRow([]); // Add an empty row first.
          row3.height = 90;
          let startColumn3 = 1; // Start from the first column.

          // Add the first group of customer details (3 columns).
          startColumn3 = addStyledCell1(row3, startColumn3, [
            {
              text: `${invoiceData[0] ? invoiceData[0]?.CustomerName : ""}\n`,
              font: { bold: true },
            },
            {
              text: `${invoiceData[0]?.InvoiceBillToStreet1 || ""}${
                invoiceData[0]?.InvoiceBillToStreet2 ? `, ${invoiceData[0].InvoiceBillToStreet2}` : ""
              },\n`,
            },
            {
              text: `${invoiceData[0]?.InvoiceBillToCity || ""}, ${matchingState.Abbreviation} ${invoiceData[0]?.InvoiceBillToZip || ""}.`,
            },
          ]);

          // Add two empty columns as a gap.
          startColumn3 = addStyledCell1(
            row3,
            startColumn3,
            [
              {
                text: "",
              },
            ],
            2,
            0
          ); // 2 columns merged as a gap, no additional gap between.

          // Add the second group of project details (3 columns).
          startColumn3 = addStyledCell1(row3, startColumn3, [
            {
              text: `${consolidateInvoiceDetail?.ProjectName || ""}\n`,
              font: { bold: true },
            },
            { text: `Project #${consolidateInvoiceDetail?.ProjID || ""}.\n` },
          ]);

          // Ensure all columns are properly set for visual alignment.
          wsData.columns.forEach((col) => {
            col.width = 15; // Adjust column width to ensure content fits.
          });

          wsData.addRow([]);

          // Adjust cell styling or other properties as needed.

          wsData.addRow([`PRINT DATE - ${currentPrintDate}`]);

          wsData.addRow([]);
          wsData.addRow([]);

          const row = wsData.addRow([]); // Add an empty row first

          // Function to add a cell with merged columns, gap, and border
          function addStyledCell(
            row,
            startColumn,
            content,
            mergeColumns = 2,
            gapColumns = 1
          ) {
            const endColumn = startColumn + mergeColumns - 1;

            // Merge cells for the object
            wsData.mergeCells(row.number, startColumn, row.number, endColumn);

            const cell = row.getCell(startColumn);
            cell.value = { richText: content };
            cell.alignment = {
              wrapText: true,
              vertical: "middle",
              horizontal: "center",
            };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "F6F7F9" },
            }; // Gray background
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            return startColumn + mergeColumns + gapColumns; // Return next start column
          }

          let startColumn = 1; // Start from the first column
          row.height = 50;
          // Total Hours
          startColumn = addStyledCell(row, startColumn, [
            { text: "Total Hours\n", font: { bold: true } },
            { text: "sum of all hours\n" },
            {
              text: `${
                consolidateInvoiceDetail && consolidateInvoiceDetail.summedData
                  ? consolidateInvoiceDetail.summedData.Hours.toFixed(2)
                  : "0.00"
              }`,
              font: { bold: true },
            },
          ]);

            // Broker Charges, one line per day rate type
          const brokerCharges =
            consolidateInvoiceDetail?.summedData?.BrokerChargeBreakdown || [];
          row.height = Math.max(row.height, 15 * (brokerCharges.length + 2));

          startColumn = addStyledCell(row, startColumn, [
            { text: "Broker Charges\n", font: { bold: true } },
            {
              text: brokerCharges
                .map((charge) => `${formatBrokerChargeLine(charge)}\n`)
                .join(""),
            },
            {
              text: `$${getBrokerChargeTotal(brokerCharges).toFixed(2)}`,
              font: { bold: true },
            },
          ]);

          // Per Diem
          startColumn = addStyledCell(row, startColumn, [
            { text: "Per Diem\n", font: { bold: true } },
            { text: "total per diem\n" },
            {
              text: `$${
                consolidateInvoiceDetail && consolidateInvoiceDetail.summedData
                  ? consolidateInvoiceDetail.summedData.PerDiem.toFixed(2)
                  : "0.00"
              }`,
              font: { bold: true },
            },
          ]);

          // cell1.fill = {
          //   type: "pattern",
          //   pattern: "solid",
          //   fgColor: { argb: grayColor },
          // };

          // cell2.fill = {
          //   type: "pattern",
          //   pattern: "solid",
          //   fgColor: { argb: grayColor },
          // };

          // cell3.fill = {
          //   type: "pattern",
          //   pattern: "solid",
          //   fgColor: { argb: grayColor },
          // };

          wsData.addRow([]);

          // Constants
          const liteColor = "#f6f7f9"; // Light gray background color
          const defaultAmount = "0.00";

          // Calculate dynamic values
          const summedData = consolidateInvoiceDetail?.summedData || {};
          const miles = summedData.Miles || 0;
          const mileageRate = summedData.mileageRate || 0;
          const totalMilesCost =
            (miles * mileageRate).toFixed(3) || defaultAmount;
          const lodgingCopiesMisc = (
            (summedData.Lodging || 0) +
            (summedData.Copies || 0) +
            (summedData.Misc || 0)
          ).toFixed(2);
          const totalOwed = (summedData.TotalOwned || 0).toFixed(2);

          function addStyledCell(
            row,
            startColumn,
            content,
            mergeColumns = 2,
            gapColumns = 1
          ) {
            if (!row) {
              throw new Error("Row is not defined");
            }

            const endColumn = startColumn + mergeColumns - 1;

            // Merge cells for the object
            wsData.mergeCells(row.number, startColumn, row.number, endColumn);

            const cell = row.getCell(startColumn);
            cell.value = { richText: content };
            cell.alignment = {
              wrapText: true,
              vertical: "middle",
              horizontal: "center",
            };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "F6F7F9" },
            }; // Gray background
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            return startColumn + mergeColumns + gapColumns; // Return next start column
          }

          // Add row to the worksheet
          const row1 = wsData.addRow([]); // Ensure row1 is initialized
          row1.height = 50;
          if (!row1) {
            throw new Error("Failed to create a row for the worksheet.");
          }

          let startColumn1 = 1;

          // Apply formatting to cells
          startColumn1 = addStyledCell(row1, startColumn1, [
            { text: "Expenses\n", font: { bold: true } }, // Expenses column
            { text: "lodging, copies & misc\n" },
            { text: `$${lodgingCopiesMisc}`, font: { bold: true } },
          ]);

          startColumn1 = addStyledCell(row1, startColumn1, [
            { text: "Miles\n", font: { bold: true } }, // Miles column
            {
              text: `${miles.toFixed(2)} miles * $${mileageRate.toFixed(
                3
              )} / mile\n`,
            },
            { text: `$${totalMilesCost}`, font: { bold: true } },
          ]);

          startColumn1 = addStyledCell(row1, startColumn1, [
            { text: "Total Owed\n", font: { bold: true } }, // Total Owed column
            { text: "total owed to broker\n" },
            { text: `$${totalOwed}`, font: { bold: true } },
          ]);

          wsData.addRow([]);
          wsData.addRow([]);
          wsData.addRow([]);

          Object.entries(groupedDataTable).forEach(
            ([brokerId, invoiceDetail]) => {
              const brokerName = invoiceDetail[0]?.BrokerName || "Unknown";
              const totalHours = invoiceDetail.reduce(
                (sum, row) => sum + (row.Hours || 0),
                0
              );
              const totalMiles = invoiceDetail.reduce(
                (sum, row) => sum + (row.Miles || 0),
                0
              );
              const totalLodging = invoiceDetail.reduce(
                (sum, row) => sum + (row.Lodging || 0),
                0
              );
              const totalCopies = invoiceDetail.reduce(
                (sum, row) => sum + (row.Copies || 0),
                0
              );
              const totalMisc = invoiceDetail.reduce(
                (sum, row) => sum + (row.Misc || 0),
                0
              );
              const totalPerDiem = invoiceDetail.reduce(
                (sum, row) => sum + (row.PerDiem || 0),
                0
              );

              const brokerNameCss = wsData.addRow([
                `Broker:
                ${brokerName || "Unknown"}`,
              ]);

              brokerNameCss.eachCell((cell) => {
                cell.font = {
                  bold: true, // Optional: Make the text bold for better visibility
                };
              });

              wsData.addRow([]);

              // Table headers
              const haeadrsCss = wsData.addRow([
                "Date",
                "Type",
                "Hours",
                "Miles",
                "Lodging",
                "Copies",
                "Misc",
                "Per Diem",
                "Description",
              ]);

              haeadrsCss.eachCell((cell) => {
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: { argb: "58a84a" }, // Light gray color (use hex ARGB format)
                };
                cell.font = {
                  bold: true, // Optional: Make the text bold for better visibility
                  color: { argb: "FFFFFFFF" },
                };
                cell.alignment = {
                  vertical: "middle", // Center vertically
                  horizontal: "center", // Center horizontally
                };
              });

              const descriptionColumnIndex = 9;
              wsData.getColumn(descriptionColumnIndex).width = 40; // Adjust width as needed
              wsData.getColumn(descriptionColumnIndex).alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true, // Ensure text wraps for the entire column
              };

              // Table data rows
              invoiceDetail
                .filter((item) => item?.BillingType != 0)
                .sort((a, b) => {
                  // Convert the date fields to Date objects for comparison
                  const dateA = new Date(a.Date);
                  const dateB = new Date(b.Date);

                  // Sort in ascending order (oldest to newest)
                  return dateA - dateB;
                })
                .forEach((invoiceDataRow) => {
                  const tableRow = wsData.addRow([
                    `${dayjs(invoiceDataRow.Date).format("MM/DD/YYYY")}`,
                    billTypeList.find(
                      (row) => row.id === invoiceDataRow.BillingType
                    )?.name || "Unknown",
                    invoiceDataRow.Hours
                      ? invoiceDataRow.Hours.toFixed(2)
                      : "0.00",
                    `${
                      invoiceDataRow.Miles
                        ? invoiceDataRow.Miles.toFixed(2)
                        : "0.00"
                    }`,
                    `$${
                      invoiceDataRow.Lodging
                        ? invoiceDataRow.Lodging.toFixed(2)
                        : "0.00"
                    }`,
                    `$${
                      invoiceDataRow.Copies
                        ? invoiceDataRow.Copies.toFixed(2)
                        : "0.00"
                    }`,
                    `$${
                      invoiceDataRow.Misc
                        ? invoiceDataRow.Misc.toFixed(2)
                        : "0.00"
                    }`,
                    `$${
                      invoiceDataRow.PerDiem
                        ? invoiceDataRow.PerDiem.toFixed(2)
                        : "0.00"
                    }`,
                    `${invoiceDataRow.Description || "No Description"}`,
                  ]);

                  // Set the row height dynamically if necessary
                  const row = wsData.getRow(tableRow.number);
                  row.height = 30; // Adjust as needed for better visibility of wrapped text

                  tableRow.eachCell((cell, colNumber) => {
                    cell.border = {
                      top: { style: "thin" },
                      left: { style: "thin" },
                      bottom: { style: "thin" },
                      right: { style: "thin" },
                    };

                    cell.alignment = {
                      vertical: "middle",
                      horizontal: "center",
                      wrapText: colNumber === descriptionColumnIndex, // Wrap text only for the "Description" column
                    };
                  });
                });

              // Total row
              const totalValues = wsData.addRow([
                "Total",
                "",
                totalHours.toFixed(2),
                totalMiles.toFixed(2),
                `$${totalLodging.toFixed(2)}`,
                `$${totalCopies.toFixed(2)}`,
                `$${totalMisc.toFixed(2)}`,
                `$${totalPerDiem.toFixed(2)}`,
                "",
              ]);

              totalValues.eachCell((cell) => {
                cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });

              wsData.getRow(totalValues.number).eachCell((cell) => {
                cell.alignment = { vertical: "middle", horizontal: "center" };
                cell.font = { bold: true, color: { argb: "000000" } }; // Example formatting for emphasis
              });

              wsData.addRow([]);
            }
          );
        });
      }

      wsData.addRow([]);
      wsData.addRow([]);

      wsData.addRow([
        "",
        `© 2018. HOS Resources, LLC. All Rights Reserved. 910 Harding Street Lafayette, LA 70503 337-296-8032 www.hosresources.com`,
      ]);

      wsData.addRow([]);

      // Add a new row with 9 columns and the content.
      const officeDetails = wsData.addRow([
        "", // Placeholder for alignment
        "📍 910 Harding Street\nLafayette, LA 70503",
        "", // Placeholder for alignment
        "📬 P.O. Box 51794\nLafayette, LA 70505",
        "", // Placeholder for alignment
        "📞 337.889.3941",
        "", // Placeholder for alignment
        "🌐 www.hosresources.com",
      ]);

      wsData.mergeCells(officeDetails.number, 2, officeDetails.number, 3); // Merge columns 2 and 3
      wsData.mergeCells(officeDetails.number, 4, officeDetails.number, 5); // Merge columns 4 and 5
      wsData.mergeCells(officeDetails.number, 6, officeDetails.number, 7); // Merge columns 6 and 7
      wsData.mergeCells(officeDetails.number, 8, officeDetails.number, 9); // Merge columns 6 and 7

      officeDetails.eachCell((cell, colNumber) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "58a84a" }, // Background color (green)
        };
        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" }, // White font color
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center", // Center content horizontally
          wrapText: true, // Wrap text for all cells
        };
      });

      officeDetails.height = 30;

      // Optionally, set the width of the columns to ensure all content fits well and is visible.
      wsData.columns.forEach((col) => {
        col.width = 15; // You can adjust this width for all columns as needed
      });

      console.log("wsData", wsData);

      try {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const invoiceDate = new Date(invoiceData[0]?.InvoiceDate);
        const monthAbbr = invoiceDate.toLocaleString("en-US", { month: "short" }); // Get month abbreviation (e.g., "Feb")
        const year = invoiceDate.getFullYear(); 
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        // link.download = `${invoiceData[0]?.CustomerName}_HOS_${invoiceData[0]?.invoiceId}.xlsx`;
        link.download = `HOS Invoice ${invoiceData[0]?.invoiceId} ${consolidateInvoiceData[0]?.ProjectName} ${invoiceData[0]?.earliestDate}.xlsx`;
        link.click();
        // window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error writing Excel file:", error);
      }
      setDownloadType("Save as");
      setFullPageView(false);
      setpdfViewer(false);
      setLoading(false);
    } catch (error) {
      console.error("Error exporting file:", error);
      setLoading(false);
    }
  };

  const convertToMMDDYYYY = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return `${month}/${day}/${year}`;
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageAttachments, setCurrentPageAttachmenats] = useState(1);

  const filteredValues = consolidateInvoiceData?.filter(
    (item) => item?.matchedDatas?.length > 0
  );
  const totalPages = filteredValues?.length == 0 ? 1 : filteredValues?.length;
  // const totalPages = consolidateInvoiceData?.filter((item) => item?.matchedBObjects?.length) || [];

  const currentBroker = filteredValues[currentPage];
  const brokerData = currentBroker || [];
  const resultArray = [brokerData];

  const handlePageChange = (event, value) => {
    setCurrentPageAttachmenats(value);
  };

  const currentFile = previewDetails[currentPageAttachments - 1];

  console.log(brokerData, "brokerDatabrokerData");
  console.log(currentBroker, "currentBrokercurrentBrokercurrentBroker");
  console.log(resultArray, "resultArrayresultArrayresultArray");

  useEffect(() => {
    settableUpdatedData(resultArray);
  }, [brokerData]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
  };

  // Function to navigate to the previous broker page
  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  // Data Pagination Handlers
  const handleLastPage = () => {
    setCurrentPage(totalPages - 1);
  };

  const handleFirstPage = () => {
    setCurrentPage(0);
  };

  const refreshData = () => {
    setConsolidateInvoiceData([]);
    settableUpdatedData([]);
    setCurrentPage(0);
    setZoomPgae(0);
    setFullPageView(false);
    setpdfViewer(false);
    setDownloadType("Save as");
    getInvoicePrintViewDetail(invoiceId);
    getAttachmentPDFApi(invoiceId);
    dispatch(getAllStatesList());
    // getProjectDetail();
  };

  return (
    <div id="samplechk">
      <Box sx={{ display: "-webkit-box" }}>
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Box
            sx={{ boxShadow: "-2px -1px 20px 0px #0000000f" }}
            className="bg-box invoicepdfbg-box"
          >
            <Grid className="pdf-top-header" container spacing={2}>
              <Grid
                sx={{ pt: "0px !important", my: "auto" }}
                item
                xs={12}
                md={7}
              >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <span
                    className="material-symbols-outlined"
                    onClick={handleFirstPage}
                    disabled={currentPage === 0}
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                  >
                    skip_previous
                  </span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                    onClick={handlePreviousPage}
                    disabled={currentPage === 0}
                  >
                    chevron_left
                  </span>
                  <span className="pagination-text active-num">
                    {currentPage + 1}
                  </span>
                  <span className="pagination-text">of {totalPages}</span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages - 1}
                  >
                    chevron_right
                  </span>
                  <span
                    className="material-symbols-outlined"
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages - 1}
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                  >
                    skip_next
                  </span>
                  <span
                    onClick={refreshData}
                    style={{ cursor: "pointer" }}
                    className="material-symbols-outlined reload-pdf"
                  >
                    refresh
                  </span>
                  {/* <span
                    className="material-symbols-outlined"
                    onClick={() => {
                      navigate(`/consolidated-invoice-form/${invoiceId}`);
                    }}
                  >
                    arrow_back
                  </span> */}
                </Stack>
              </Grid>
              <Grid sx={{ pt: "0px !important" }} item xs={12} md={5}>
                <Stack direction="row" spacing={0}>
                  <FormControl className="whole-select" fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={zoomPgae}
                      onChange={handleChangeZoomPage}
                    >
                      <MenuItem value={0.01}>Whole Page</MenuItem>
                      <MenuItem value={500}>500 %</MenuItem>
                      <MenuItem value={200}>200 %</MenuItem>
                      <MenuItem value={150}>150 %</MenuItem>
                      <MenuItem value={0}>100 %</MenuItem>
                      <MenuItem value={-10}>75 %</MenuItem>
                      <MenuItem value={-25}>50 %</MenuItem>
                      <MenuItem value={-50}>25 %</MenuItem>
                      <MenuItem value={-75}>10 %</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className="saveas-btn" fullWidth>
                    <Select
                      id="demo-simple-select"
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            save
                          </span>
                        </InputAdornment>
                      }
                      value={downloadType}
                      onChange={handleChangeDownloadType}
                      disabled={
                        consolidateInvoiceData?.length == 0 &&
                        (invoiceTotalOwned == invoiceTotalStatic
                          ? invoiceTotalOwned == "0.00"
                          : invoiceData[0]?.InvoiceTotal == "0.00")
                      }
                    >
                      <MenuItem value={"Save as"}>Save as</MenuItem>
                      <MenuItem value={"PDF"}>PDF</MenuItem>
                      <MenuItem value={"EXCEL"}>EXCEL</MenuItem>
                      <MenuItem value={"DOC"}>WORD</MenuItem>
                      <MenuItem value={"IMAGE"}>IMAGE</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    className="primary-btn save-print-btn"
                    disabled={
                      consolidateInvoiceData?.length == 0 &&
                      (invoiceTotalOwned == invoiceTotalStatic
                        ? invoiceTotalOwned == "0.00"
                        : invoiceData[0]?.InvoiceTotal == "0.00")
                    }
                    onClick={() => {
                      setFullPageView(true);
                      setpdfViewer(true);
                      setZoomPgae(0);
                      setTimeout(() => {
                        if (previewDetails?.length == 0) {
                          handlePrintContent();
                        } else {
                          handlePrint();
                        }
                      }, 2000);
                    }}
                  >
                    <span className="material-symbols-outlined">print</span>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <div
              style={
                zoomPgae
                  ? {
                      overflow: zoomPgae != "0.01" ? "scroll" : "",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#fff",
                    }
                  : {}
              }
            >
              <div
                ref={captureRef}
                id="capturediv"
                style={
                  zoomPgae
                    ? {
                        transform: `scale(${zoomPgae / 100 + 1})`,
                        transformOrigin: "0 0",
                      }
                    : {}
                }
              >
                <Stack
                  sx={{ mt: "27px" }}
                  direction="row"
                  justifyContent="space-between"
                  spacing={2}
                >
                  <img src={pdfMainLogo} />

                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Box
                      sx={{
                        borderRight: "4px solid green",
                        paddingRight: "10px",
                        mt: "auto !important",
                        mb: "auto !important",
                      }}
                    >
                      <Typography className="total-due">INVOICE NO:</Typography>
                      <Typography className="total-amount">
                        {invoiceData[0] ? invoiceData[0].invoiceId : "--"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        borderRight: "4px solid green",
                        paddingRight: "10px",
                        mt: "auto !important",
                        mb: "auto !important",
                      }}
                    >
                      <Typography className="total-due">TOTAL DUE:</Typography>
                      <Typography className="total-amount">
                        $
                        {invoiceTotalOwned == invoiceTotalStatic
                          ? invoiceTotalOwned?.toFixed(2)
                          : invoiceData[0]?.InvoiceTotal?.toFixed(2)
                          ? invoiceData[0]?.InvoiceTotal?.toFixed(2)
                          : "0.00"}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                {/* Consolidated map started */}

                {fullPageView == false
                  ? tableUpdatedData &&
                    tableUpdatedData.length > 0 &&
                    tableUpdatedData
                      .filter((val) => val?.matchedDatas?.length > 0)
                      // .filter((val) => val?.matchedBObjects?.length > 0) // Ensure return of true/false
                      // .filter((item) => item?.data?.length > 0)
                      .map((consolidateInvoiceDetail) => {
                        // const [startDate, endDate] =
                        //   consolidateInvoiceDetail?.periodDate?.split(" - ");
                        // const formattedStartDate = convertToMMDDYYYY(startDate);
                        // const formattedEndDate = convertToMMDDYYYY(endDate);
                        console.log(
                          consolidateInvoiceDetail,
                          "consolidateInvoiceDetailconsolidateInvoiceDetail"
                        );
                        const groupedDataTable =
                          consolidateInvoiceDetail.matchedDatas.reduce(
                            (acc, curr) => {
                              const { BrokerID } = curr;
                              if (!acc[BrokerID]) {
                                acc[BrokerID] = [];
                              }
                              acc[BrokerID].push(curr);
                              return acc;
                            },
                            {}
                          );
                        return (
                          <div>
                            <Grid
                              sx={{
                                padding: "12px 13px",
                                background: "#F6F7F9",
                                mt: "30px",
                                borderBottom: "1px solid #E3E5E8",
                              }}
                              container
                            >
                              <Grid item xs={12} md={6}>
                                <Typography className="preview-bill-date">
                                  Billing Period: {""}
                                  {consolidateInvoiceDetail.periodDate
                                    ? consolidateInvoiceDetail.periodDate
                                    : "No billing statement available."}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Box
                              sx={{
                                border: "1px solid #E0E2E7",
                                borderRadius: "12px",
                                padding: "15px",
                                marginTop: "15px",
                              }}
                            >
                              <Table
                                className="A4-print-table"
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  display: "table",
                                  borderBottom: "1px solid #ededed",
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <TableHead>
                                  <TableRow
                                    style={{ verticalAlign: "baseline" }}
                                  >
                                    <TableCell style={{ textAlign: "left" }}>
                                      <Typography className="address-title">
                                        {invoiceData[0]
                                          ? invoiceData[0].CustomerName
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        {invoiceData[0].InvoiceBillToStreet1
                                          ? invoiceData[0]
                                              .InvoiceBillToStreet1 + ", "
                                          : ""}
                                        {/* <br /> */}
                                        {invoiceData[0].InvoiceBillToStreet2
                                          ? invoiceData[0]
                                              .InvoiceBillToStreet2 + ", "
                                          : ""}
                                           <br />
                                        {/* <br /> */}
                                        {invoiceData[0].InvoiceBillToCity
                                          ? invoiceData[0].InvoiceBillToCity +
                                            ", "
                                          : ""}
                                       
                                        {invoiceData[0]?.InvoiceBillToState &&
                                        matchingState?.Abbreviation
                                          ? matchingState.Abbreviation + " "
                                          // + ", "
                                          : ""}
                                        {invoiceData[0]
                                          ? invoiceData[0].InvoiceBillToZip
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        PRINT DATE - {currentPrintDate}
                                      </Typography>
                                    </TableCell>
                                    <TableCell style={{ textAlign: "right" }}>
                                      <Typography className="address-title">
                                        {consolidateInvoiceDetail
                                          ? consolidateInvoiceDetail.ProjectName
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        Project #
                                        {consolidateInvoiceDetail
                                          ? consolidateInvoiceDetail.ProjID
                                          : ""}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              </Table>
                              {/* <Grid
                                sx={{
                                  mt: "15px",
                                }}
                                container
                              >
                                <Grid item xs={12} md={6}>
                                  <Typography className="address-title">
                                    {invoiceData[0]
                                      ? invoiceData[0].CustomerName
                                      : ""}
                                  </Typography>
                                  <Typography className="address-text">
                                    {invoiceData[0].InvoiceBillToStreet1
                                      ? invoiceData[0].InvoiceBillToStreet1 +
                                        ", "
                                      : ""}
                                    <br />
                                    {invoiceData[0].InvoiceBillToStreet2
                                      ? invoiceData[0].InvoiceBillToStreet2 +
                                        ", "
                                      : ""}
                                    <br />
                                    {invoiceData[0].InvoiceBillToCity
                                      ? invoiceData[0].InvoiceBillToCity + ", "
                                      : ""}
                                    <br />
                                    {invoiceData[0]?.InvoiceBillToState &&
                                    matchingState?.Abbreviation
                                      ? matchingState.Abbreviation + ", "
                                      : ""}
                                    {invoiceData[0]
                                      ? invoiceData[0].InvoiceBillToZip
                                      : ""}
                                  </Typography>
                                  <Typography className="address-text">
                                    PRINT DATE - {currentPrintDate}
                                  </Typography>
                                </Grid>
                                <Grid
                                  sx={{ textAlign: "right" }}
                                  item
                                  xs={12}
                                  md={6}
                                >
                                  <Typography className="address-title">
                                    {consolidateInvoiceDetail
                                      ? consolidateInvoiceDetail.ProjectName
                                      : ""}
                                  </Typography>
                                  <Typography className="address-text">
                                    Project #
                                    {consolidateInvoiceDetail
                                      ? consolidateInvoiceDetail.ProjID
                                      : ""}
                                  </Typography>
                                </Grid>
                              </Grid> */}

                              {/* <Grid spacing={2} sx={{ mt: "15px" }} container>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Total Hours
                                    </Typography>
                                    <Typography className="stm-text">
                                      sum of all hours{" "}
                                    </Typography>
                                    <Typography className="stm-count">
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.Hours.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Broker Charges
                                    </Typography>
                                    <Typography className="stm-text">
                                      (
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.Hours.toFixed(
                                            2
                                          )
                                        : "0.00"}{" "}
                                      / 8) * $
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.BillableDayRate.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </Typography>
                                    <Typography className="stm-count">
                                      $
                                      {invoiceData
                                        ? (
                                            ((consolidateInvoiceDetail
                                              ?.summedData?.Hours || 0) /
                                              8) *
                                            (consolidateInvoiceDetail
                                              ?.summedData?.BillableDayRate ||
                                              0)
                                          ).toFixed(2)
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Per Diem
                                    </Typography>
                                    <Typography className="stm-text">
                                      total per diem
                                    </Typography>
                                    <Typography className="stm-count">
                                      $
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.PerDiem.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Expenses
                                    </Typography>
                                    <Typography className="stm-text">
                                      lodging, copies & misc
                                    </Typography>
                                    <Typography className="stm-count">
                                      $
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? (
                                            consolidateInvoiceDetail.summedData
                                              .Lodging +
                                            consolidateInvoiceDetail.summedData
                                              .Copies +
                                            consolidateInvoiceDetail.summedData
                                              .Misc
                                          ).toFixed(2)
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Miles
                                    </Typography>
                                    <Typography className="stm-text">
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.Miles.toFixed(
                                            2
                                          )
                                        : "0.00"}{" "}
                                      miles * $
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail?.summedData
                                        ?.mileageRate
                                        ? consolidateInvoiceDetail?.summedData?.mileageRate.toFixed(
                                            2
                                          )
                                        : "0.00"}{" "}
                                      / mile
                                    </Typography>
                                    <Typography className="stm-count">
                                      $
                                      {invoiceData[0]
                                        ? (
                                            (consolidateInvoiceDetail &&
                                            consolidateInvoiceDetail.summedData
                                              ? consolidateInvoiceDetail
                                                  .summedData.Miles
                                              : 0) *
                                            (consolidateInvoiceDetail &&
                                            consolidateInvoiceDetail?.summedData
                                              ?.mileageRate
                                              ? consolidateInvoiceDetail
                                                  ?.summedData?.mileageRate
                                              : 0)
                                          ).toFixed(2)
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box className="statement-box">
                                    <Typography className="stm-title">
                                      Total Owed
                                    </Typography>
                                    <Typography className="stm-text">
                                      total owed to broker
                                    </Typography>
                                    <Typography className="stm-count">
                                      $
                                      {consolidateInvoiceDetail &&
                                      consolidateInvoiceDetail.summedData
                                        ? consolidateInvoiceDetail.summedData.TotalOwned.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid> */}

                              <table
                                className="print-main-statement"
                                style={{
                                  width: "100%",
                                  marginTop: "15px",
                                  textAlign: "left",
                                  borderSpacing: "collapse",
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <tr>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Total Hours
                                      </Typography>
                                      <Typography className="stm-text">
                                        sum of all hours{" "}
                                      </Typography>
                                      <Typography className="stm-count">
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail.summedData
                                          ? consolidateInvoiceDetail.summedData.Hours.toFixed(
                                              2
                                            )
                                          : "0.00"}
                                      </Typography>
                                    </Box>
                                  </th>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Broker Charges
                                      </Typography>
                                      {(consolidateInvoiceDetail?.summedData
                                        ?.BrokerChargeBreakdown || []
                                      ).map((charge) => (
                                        <Typography className="stm-text" key={charge.selection}>
                                          ({charge.hours.toFixed(2)} / 8) * ${charge.rate.toFixed(2)} {charge.selection.toLowerCase()}
                                        </Typography>
                                      ))}
                                      <Typography className="stm-count">
                                        $
                                         {getBrokerChargeTotal(
                                          consolidateInvoiceDetail?.summedData?.BrokerChargeBreakdown
                                        ).toFixed(2)}
                                      </Typography>
                                    </Box>
                                  </th>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Per Diem
                                      </Typography>
                                      <Typography className="stm-text">
                                        total per diem
                                      </Typography>
                                      <Typography className="stm-count">
                                        $
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail.summedData
                                          ? consolidateInvoiceDetail.summedData.PerDiem.toFixed(
                                              2
                                            )
                                          : "0.00"}
                                      </Typography>
                                    </Box>
                                  </th>
                                </tr>
                                <tr>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Expenses
                                      </Typography>
                                      <Typography className="stm-text">
                                        lodging, copies & misc
                                      </Typography>
                                      <Typography className="stm-count">
                                        $
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail.summedData
                                          ? (
                                              consolidateInvoiceDetail
                                                .summedData.Lodging +
                                              consolidateInvoiceDetail
                                                .summedData.Copies +
                                              consolidateInvoiceDetail
                                                .summedData.Misc
                                            ).toFixed(2)
                                          : "0.00"}
                                      </Typography>
                                    </Box>
                                  </th>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Miles
                                      </Typography>
                                      <Typography className="stm-text">
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail.summedData
                                          ? consolidateInvoiceDetail.summedData.Miles.toFixed(
                                              2
                                            )
                                          : "0.00"}{" "}
                                        miles * $
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail?.summedData
                                          ?.mileageRate
                                          ? consolidateInvoiceDetail?.summedData?.mileageRate.toFixed(
                                              3
                                            )
                                          : "0.00"}{" "}
                                        / mile
                                      </Typography>
                                      <Typography className="stm-count">
                                        $
                                        {invoiceData[0]
                                          ? (
                                              (consolidateInvoiceDetail &&
                                              consolidateInvoiceDetail.summedData
                                                ? consolidateInvoiceDetail
                                                    .summedData.Miles
                                                : 0) *
                                              (consolidateInvoiceDetail &&
                                              consolidateInvoiceDetail
                                                ?.summedData?.mileageRate
                                                ? consolidateInvoiceDetail
                                                    ?.summedData?.mileageRate
                                                : 0)
                                            ).toFixed(3)
                                          : "0.000"}
                                      </Typography>
                                    </Box>
                                  </th>
                                  <th>
                                    <Box className="statement-box">
                                      <Typography className="stm-title">
                                        Total Owed
                                      </Typography>
                                      <Typography className="stm-text">
                                        total owed to broker
                                      </Typography>
                                      <Typography className="stm-count">
                                        $
                                        {consolidateInvoiceDetail &&
                                        consolidateInvoiceDetail.summedData
                                          ? consolidateInvoiceDetail.summedData.TotalOwned.toFixed(
                                              2
                                            )
                                          : "0.00"}
                                      </Typography>
                                    </Box>
                                  </th>
                                </tr>
                              </table>
                            </Box>
                            {Object.entries(groupedDataTable).map(
                              ([brokerId, invoiceDetail]) => {
                                console.log(
                                  invoiceDetail,
                                  "invoicedetatisasjdjshdhj"
                                );

                                const brokerName =
                                  invoiceDetail[0]?.BrokerName || "Unknown";
                                // Calculate totals for the group
                                const totalHours = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Hours || 0),
                                  0
                                );
                                const totalMiles = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Miles || 0),
                                  0
                                );
                                const totalLodging = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Lodging || 0),
                                  0
                                );
                                const totalCopies = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Copies || 0),
                                  0
                                );
                                const totalMisc = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Misc || 0),
                                  0
                                );
                                const totalPerDiem = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.PerDiem || 0),
                                  0
                                );
                                // const totalHours = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Hours || 0),
                                //   0
                                // );
                                console.log(
                                  totalHours,
                                  "invototalHoursicedetatisasjdjshdhj"
                                );
                                // const totalMiles = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Miles || 0),
                                //   0
                                // );
                                // const totalLodging = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Lodging || 0),
                                //   0
                                // );
                                // const totalCopies = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Copies || 0),
                                //   0
                                // );
                                // const totalMisc = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Misc || 0),
                                //   0
                                // );
                                // const totalPerDiem = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.PerDiem || 0),
                                //   0
                                // );

                                // Render table
                                return (
                                  <TableContainer
                                    key={brokerId}
                                    className="preview-table"
                                    component={Paper}
                                  >
                                    <Typography className="address-title">
                                      Broker: {brokerName || "Unknown"}
                                    </Typography>

                                    <Table
                                      sx={{
                                        minWidth: 650,
                                        pageBreakInside: "avoid",
                                        borderCollapse: "collapse",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Date</TableCell>
                                          <TableCell>Day Rate Type</TableCell>
                                          <TableCell>Type</TableCell>
                                          <TableCell>Hours</TableCell>
                                          <TableCell>Miles</TableCell>
                                          <TableCell>Lodging</TableCell>
                                          <TableCell>Copies</TableCell>
                                          <TableCell>Misc</TableCell>
                                          <TableCell sx={{ minWidth: "54px" }}>
                                            Per Diem
                                          </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {invoiceDetail
                                          .filter(
                                            (item) => item?.BillingType != 0
                                          )
                                          .sort((a, b) => {
                                            // Convert the date fields to Date objects for comparison
                                            const dateA = new Date(a.Date); // Replace `a.Date` with the actual date field name
                                            const dateB = new Date(b.Date); // Replace `b.Date` with the actual date field name

                                            // Sort in ascending order (oldest to newest)
                                            return dateA - dateB;
                                          })
                                          .map((invoiceDataRow) => (
                                            <TableRow
                                              key={
                                                invoiceDataRow.BillingDetailID
                                              }
                                              sx={{
                                                "&:last-child td, &:last-child th":
                                                  {
                                                    border: 0,
                                                  },
                                              }}
                                            >
                                              <TableCell>
                                                <span>
                                                  {dayjs(
                                                    invoiceDataRow.Date
                                                  ).format("MM/DD/YYYY")}
                                                </span>
                                                <br />
                                                <span className="pv-description">
                                                  {invoiceDataRow.Description ||
                                                    "No Description"}
                                                </span>
                                              </TableCell>
                                              <TableCell>
                                                {getPrintDayRateType(invoiceDataRow)}
                                              </TableCell>
                                              <TableCell>
                                                {billTypeList.find(
                                                  (row) =>
                                                    row.id ===
                                                    invoiceDataRow.BillingType
                                                )?.name || "Unknown"}
                                              </TableCell>
                                              <TableCell>
                                                {invoiceDataRow.Hours
                                                  ? invoiceDataRow.Hours.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                {invoiceDataRow.Miles
                                                  ? invoiceDataRow.Miles.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Lodging
                                                  ? invoiceDataRow.Lodging.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Copies
                                                  ? invoiceDataRow.Copies.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Misc
                                                  ? invoiceDataRow.Misc.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.PerDiem
                                                  ? invoiceDataRow.PerDiem.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                            </TableRow>
                                          ))}

                                        <TableRow>
                                          <TableCell colSpan={3}>
                                            <strong>Total</strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              {totalHours.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              {totalMiles.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalLodging.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalCopies.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalMisc.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalPerDiem.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                );
                              }
                            )}
                            {previewDetails?.length > 0 && (
                              <>
                                <br />
                                <br />
                                <div>
                                  <Grid
                                    container
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    {/* Title */}
                                    <Typography
                                      variant="h6"
                                      className="address-title"
                                    >
                                      Attachments:
                                    </Typography>

                                    {previewDetails?.length > 0 && (
                                      <Pagination
                                        count={previewDetails.length} // Total number of files
                                        page={currentPageAttachments}
                                        onChange={handlePageChange}
                                        color="primary"
                                      />
                                    )}
                                  </Grid>

                                  {/* Display the current file */}
                                  {previewDetails?.length > 0 && (
                                    <Box
                                      sx={{
                                        marginTop: "20px",
                                        width: "210mm", // A4 width
                                        height: "250mm", // A4 height
                                        padding: "10mm",
                                        border: "1px solid #ccc", // Optional border for the "page"
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "start",
                                        alignItems: "start",
                                      }}
                                    >
                                      {/* File Name */}
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: "bold",
                                          marginBottom: "10px",
                                        }}
                                      >
                                        {currentFile.fileName}
                                      </Typography>

                                      {/* Render Image Files */}
                                      {[
                                        "png",
                                        "jpg",
                                        "jpeg",
                                        "svg",
                                        "webp",
                                      ].includes(
                                        currentFile.fileName
                                          .split(".")
                                          .pop()
                                          .toLowerCase()
                                      ) && (
                                        <img
                                          src={currentFile.filePath}
                                          alt={currentFile.fileName}
                                          style={{
                                            width: "100%",
                                            height: "auto",
                                            maxHeight: "250mm",
                                            objectFit: "contain",
                                          }}
                                        />
                                      )}

                                      {/* Render PDF Files */}
                                      {currentFile.fileName
                                        .split(".")
                                        .pop()
                                        .toLowerCase() === "pdf" && (
                                        <embed
                                          src={currentFile.filePath}
                                          type="application/pdf"
                                          width="100%"
                                          height="100%"
                                          style={{ objectFit: "contain" }}
                                        />
                                      )}

                                      {/* Link to View File */}
                                      {/* <Link
        href={currentFile.filePath}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ marginTop: "10px" }}
      >
        View File
      </Link> */}
                                    </Box>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        );
                      })
                  : consolidateInvoiceData &&
                    consolidateInvoiceData.length > 0 &&
                    consolidateInvoiceData
                      .filter((val) => val?.matchedDatas?.length > 0)
                      .map((consolidateInvoiceDetail) => {
                        const groupedDataTable =
                          consolidateInvoiceDetail.matchedDatas.reduce(
                            (acc, curr) => {
                              const { BrokerID } = curr;
                              if (!acc[BrokerID]) {
                                acc[BrokerID] = [];
                              }
                              acc[BrokerID].push(curr);
                              return acc;
                            },
                            {}
                          );
                        console.log(
                          consolidateInvoiceDetail,
                          "consolidateInvoiceDetailconsolidateInvoiceDetail"
                        );
                        return (
                          <div>
                            <Grid
                              sx={{
                                padding: "12px 13px",
                                background: "#F6F7F9",
                                mt: "30px",
                                borderBottom: "1px solid #E3E5E8",
                              }}
                              container
                            >
                              <Grid item xs={12} md={6}>
                                <Typography className="preview-bill-date">
                                  Billing Period: {""}
                                  {consolidateInvoiceDetail.periodDate
                                    ? consolidateInvoiceDetail.periodDate
                                    : "No billing statement available."}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Box
                              sx={{
                                border: "1px solid #E0E2E7",
                                borderRadius: "12px",
                                padding: "15px",
                                marginTop: "15px",
                              }}
                            >
                              <Table
                                className="A4-print-table"
                                sx={{
                                  mt: "15px",
                                  borderBottom: "1px solid #ededed",
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>
                                      <Typography className="address-title">
                                        {invoiceData[0]
                                          ? invoiceData[0].CustomerName
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        {invoiceData[0].InvoiceBillToStreet1
                                          ? invoiceData[0]
                                              .InvoiceBillToStreet1 + ", "
                                          : ""}
                                        {/* <br /> */}
                                        {invoiceData[0].InvoiceBillToStreet2
                                          ? invoiceData[0]
                                              .InvoiceBillToStreet2 + ", "
                                          : ""}
                                        <br />
                                        {invoiceData[0].InvoiceBillToCity
                                          ? invoiceData[0].InvoiceBillToCity +
                                            ", "
                                          : ""}
                                        {/* <br /> */}
                                        {invoiceData[0]?.InvoiceBillToState &&
                                        matchingState?.Abbreviation
                                          ? matchingState.Abbreviation + " "
                                          // + ", "
                                          : ""}
                                        {invoiceData[0]
                                          ? invoiceData[0].InvoiceBillToZip
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        PRINT DATE - {currentPrintDate}
                                      </Typography>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "right" }}>
                                      <Typography className="address-title">
                                        {consolidateInvoiceDetail
                                          ? consolidateInvoiceDetail.ProjectName
                                          : ""}
                                      </Typography>
                                      <Typography className="address-text">
                                        Project #
                                        {consolidateInvoiceDetail
                                          ? consolidateInvoiceDetail.ProjID
                                          : ""}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              </Table>

                              <Table
                                className="A4-print-table"
                                sx={{
                                  mt: "15px",
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Total Hours
                                        </Typography>
                                        <Typography className="stm-text">
                                          sum of all hours{" "}
                                        </Typography>
                                        <Typography className="stm-count">
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail.summedData
                                            ? consolidateInvoiceDetail.summedData.Hours.toFixed(
                                                2
                                              )
                                            : "0.00"}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Broker Charges
                                        </Typography>
                                        {(consolidateInvoiceDetail?.summedData
                                          ?.BrokerChargeBreakdown || []
                                        ).map((charge) => (
                                          <Typography className="stm-text" key={charge.selection}>
                                            ({charge.hours.toFixed(2)} / 8) * ${charge.rate.toFixed(2)} {charge.selection.toLowerCase()}
                                          </Typography>
                                        ))}
                                        <Typography className="stm-count">
                                          $
                                          {getBrokerChargeTotal(
                                            consolidateInvoiceDetail?.summedData?.BrokerChargeBreakdown
                                          ).toFixed(2)}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Per Diem
                                        </Typography>
                                        <Typography className="stm-text">
                                          total per diem
                                        </Typography>
                                        <Typography className="stm-count">
                                          $
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail.summedData
                                            ? consolidateInvoiceDetail.summedData.PerDiem.toFixed(
                                                2
                                              )
                                            : "0.00"}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Expenses
                                        </Typography>
                                        <Typography className="stm-text">
                                          lodging, copies & misc
                                        </Typography>
                                        <Typography className="stm-count">
                                          $
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail.summedData
                                            ? (
                                                consolidateInvoiceDetail
                                                  .summedData.Lodging +
                                                consolidateInvoiceDetail
                                                  .summedData.Copies +
                                                consolidateInvoiceDetail
                                                  .summedData.Misc
                                              ).toFixed(2)
                                            : "0.00"}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Miles
                                        </Typography>
                                        <Typography className="stm-text">
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail.summedData
                                            ? consolidateInvoiceDetail.summedData.Miles.toFixed(
                                                2
                                              )
                                            : "0.00"}{" "}
                                          miles * $
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail?.summedData
                                            ?.mileageRate
                                            ? consolidateInvoiceDetail?.summedData?.mileageRate.toFixed(
                                                3
                                              )
                                            : "0.000"}{" "}
                                          / mile
                                        </Typography>
                                        <Typography className="stm-count">
                                          $
                                          {invoiceData[0]
                                            ? (
                                                (consolidateInvoiceDetail &&
                                                consolidateInvoiceDetail.summedData
                                                  ? consolidateInvoiceDetail
                                                      .summedData.Miles
                                                  : 0) *
                                                (consolidateInvoiceDetail &&
                                                consolidateInvoiceDetail
                                                  ?.summedData?.mileageRate
                                                  ? consolidateInvoiceDetail
                                                      ?.summedData?.mileageRate
                                                  : 0)
                                              ).toFixed(3)
                                            : "0.000"}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Box className="statement-box">
                                        <Typography className="stm-title">
                                          Total Owed
                                        </Typography>
                                        <Typography className="stm-text">
                                          total owed to broker
                                        </Typography>
                                        <Typography className="stm-count">
                                          $
                                          {consolidateInvoiceDetail &&
                                          consolidateInvoiceDetail.summedData
                                            ? consolidateInvoiceDetail.summedData.TotalOwned.toFixed(
                                                2
                                              )
                                            : "0.00"}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              </Table>
                            </Box>

                            {Object.entries(groupedDataTable).map(
                              ([brokerId, invoiceDetail]) => {
                                const brokerName =
                                  invoiceDetail[0]?.BrokerName || "Unknown";
                                console.log(
                                  invoiceDetail,
                                  "invoicedetatisasjdjshdhj"
                                );

                                // Calculate totals
                                const totalHours = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Hours || 0),
                                  0
                                );
                                const totalMiles = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Miles || 0),
                                  0
                                );
                                const totalLodging = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Lodging || 0),
                                  0
                                );
                                const totalCopies = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Copies || 0),
                                  0
                                );
                                const totalMisc = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.Misc || 0),
                                  0
                                );
                                const totalPerDiem = invoiceDetail.reduce(
                                  (sum, row) => sum + (row.PerDiem || 0),
                                  0
                                );
                                // const totalHours = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Hours || 0),
                                //   0
                                // );
                                console.log(
                                  totalHours,
                                  "invototalHoursicedetatisasjdjshdhj"
                                );
                                // const totalMiles = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Miles || 0),
                                //   0
                                // );
                                // const totalLodging = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Lodging || 0),
                                //   0
                                // );
                                // const totalCopies = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Copies || 0),
                                //   0
                                // );
                                // const totalMisc = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.Misc || 0),
                                //   0
                                // );
                                // const totalPerDiem = invoiceDetail.reduce(
                                //   (sum, row) => sum + (row.PerDiem || 0),
                                //   0
                                // );

                                // Render table
                                return (
                                  <TableContainer
                                    key={brokerId}
                                    className="preview-table"
                                    component={Paper}
                                  >
                                    <Typography className="address-title">
                                      Broker: {brokerName || "Unknown"}
                                    </Typography>

                                    <Table
                                      sx={{
                                        minWidth: 650,
                                        pageBreakInside: "avoid",
                                        borderCollapse: "collapse",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Date</TableCell>
                                          <TableCell>Day Rate Type</TableCell>
                                          <TableCell>Type</TableCell>
                                          <TableCell>Hours</TableCell>
                                          <TableCell>Miles</TableCell>
                                          <TableCell>Lodging</TableCell>
                                          <TableCell>Copies</TableCell>
                                          <TableCell>Misc</TableCell>
                                          <TableCell>Per Diem</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {invoiceDetail
                                          .filter(
                                            (item) => item?.BillingType != 0
                                          )
                                          .sort((a, b) => {
                                            // Convert the date fields to Date objects for comparison
                                            const dateA = new Date(a.Date); // Replace `a.Date` with the actual date field name
                                            const dateB = new Date(b.Date); // Replace `b.Date` with the actual date field name

                                            // Sort in ascending order (oldest to newest)
                                            return dateA - dateB;
                                          })
                                          .map((invoiceDataRow) => (
                                            <TableRow
                                              key={
                                                invoiceDataRow.BillingDetailID
                                              }
                                              sx={{
                                                "&:last-child td, &:last-child th":
                                                  {
                                                    border: 0,
                                                  },
                                              }}
                                            >
                                              <TableCell>
                                                <span>
                                                  {invoiceDataRow.Date}
                                                </span>
                                                <br />
                                                <span className="pv-description">
                                                  {invoiceDataRow.Description ||
                                                    "No Description"}
                                                </span>
                                              </TableCell>
                                              <TableCell>
                                                {getPrintDayRateType(invoiceDataRow)}
                                              </TableCell>
                                              <TableCell>
                                                {billTypeList.find(
                                                  (row) =>
                                                    row.id ===
                                                    invoiceDataRow.BillingType
                                                )?.name || "Unknown"}
                                              </TableCell>
                                              <TableCell>
                                                {invoiceDataRow.Hours
                                                  ? invoiceDataRow.Hours.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                {invoiceDataRow.Miles
                                                  ? invoiceDataRow.Miles.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Lodging
                                                  ? invoiceDataRow.Lodging.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Copies
                                                  ? invoiceDataRow.Copies.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.Misc
                                                  ? invoiceDataRow.Misc.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                              <TableCell>
                                                $
                                                {invoiceDataRow.PerDiem
                                                  ? invoiceDataRow.PerDiem.toFixed(
                                                      2
                                                    )
                                                  : "0.00"}
                                              </TableCell>
                                            </TableRow>
                                          ))}

                                        <TableRow>
                                          <TableCell colSpan={3}>
                                            <strong>Total</strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              {totalHours.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              {totalMiles.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalLodging.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalCopies.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalMisc.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                          <TableCell>
                                            <strong>
                                              ${totalPerDiem.toFixed(2)}
                                            </strong>
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                );
                              }
                            )}
                          </div>
                        );
                      })}

                {/* Consolidated map end */}

                {/* <Grid spacing={2} sx={{ mt: "30px" }} container>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">Total Hour</Typography>
                    <Typography className="stm-text">
                      statement of all hour{" "}
                    </Typography>
                    <Typography className="stm-count">
                      {invoiceData[0] && invoiceData[0].InvoiceBrokerHours
                        ? invoiceData[0].InvoiceBrokerHours.toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">
                      Broker Charges
                    </Typography>
                    {getPrintBrokerCharges(
                      invoiceData[0]?.invoiceDetails
                        ? JSON.parse(invoiceData[0].invoiceDetails)
                        : [],
                      invoiceData[0] || {}
                    ).map((charge) => (
                      <Typography className="stm-text" key={charge.selection}>
                        ({charge.hours.toFixed(2)} / 8) * ${charge.rate.toFixed(2)} {charge.selection.toLowerCase()}
                      </Typography>
                    ))}
                    <Typography className="stm-count">
                      $
                      {getPrintBrokerCharges(
                        invoiceData[0]?.invoiceDetails
                          ? JSON.parse(invoiceData[0].invoiceDetails)
                          : [],
                        invoiceData[0] || {}
                      )
                        .reduce((total, charge) => total + charge.charge, 0)
                        .toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">Per Diem</Typography>
                    <Typography className="stm-text">total per diem</Typography>
                    <Typography className="stm-count">
                      {invoiceData[0] && invoiceData[0].InvoicePerDiem
                        ? invoiceData[0].InvoicePerDiem.toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">Expenses</Typography>
                    <Typography className="stm-text">
                      lodging, copies, & misc
                    </Typography>
                    <Typography className="stm-count">0.00</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">Miles</Typography>
                    <Typography className="stm-text">
                      {invoiceData[0]
                        ? invoiceData[0].InvoiceMiles.toFixed(2)
                        : "0.00"}{" "}
                      miles * $
                      {invoiceData[0]
                        ? invoiceData[0].InvoiceMileageRate.toFixed(2)
                        : "0.00"}{" "}
                      / mile
                    </Typography>
                    <Typography className="stm-count">
                      {invoiceData[0]
                        ? (
                            (invoiceData[0].InvoiceMiles
                              ? invoiceData[0].InvoiceMiles
                              : 0) *
                            (invoiceData[0].InvoiceMileageRate
                              ? invoiceData[0].InvoiceMileageRate
                              : 0)
                          ).toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="statement-box">
                    <Typography className="stm-title">Total Owned</Typography>
                    <Typography className="stm-text">
                      total owed to broker
                    </Typography>
                    <Typography className="stm-count">
                      {invoiceData[0]
                        ? invoiceData[0].InvoiceTotal.toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                </Grid>
              </Grid> */}

                {/* <Stack
              className="hours-box"
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <Typography className="hour-title">Hours</Typography>
                <Typography className="hour-text">sum of all hours</Typography>
                <Typography className="hour-charge">{ invoiceData[0] ? invoiceData[0].InvoiceBrokerHours.toFixed(2): 0.00  }</Typography>
              </Box>
              <Box>
                <Typography className="hour-title">Day Rate</Typography>
                <Typography className="hour-text">
                  amt paid per 8 hours
                </Typography>
                <Typography className="hour-charge">${ invoiceData[0] ? invoiceData[0].InvoiceDayRate.toFixed(2): 0.00  }</Typography>
              </Box>
              <Box>
                <Typography className="hour-title">Per Diem</Typography>
                <Typography className="hour-text">total per diem</Typography>
                <Typography className="hour-charge">${ invoiceData[0] ? invoiceData[0].InvoicePerDiem.toFixed(2): 0.00  }</Typography>
              </Box>
              <Box>
                <Typography className="hour-title">Expenses</Typography>
                <Typography className="hour-text">
                  lodging, copies, & misc
                </Typography>
                <Typography className="hour-charge">$

                {
                    invoiceData[0]
                        ? (
                            (invoiceData[0].Copies ? invoiceData[0].Copies : 0) +
                            (invoiceData[0].Lodging ? invoiceData[0].Lodging : 0) +
                            (invoiceData[0].Misc ? invoiceData[0].Misc : 0)
                        ).toFixed(2)
                        : '0.00'
                }
                  
                  </Typography>
              </Box>
              <Box>
                <Typography className="hour-title">Miles</Typography>
                <Typography className="hour-text">
                { invoiceData[0] ? invoiceData[0].InvoiceMiles.toFixed(2): 0.00  } miles * ${ invoiceData[0] ? invoiceData[0].InvoiceMileageRate.toFixed(2): 0.00  } / mile
                </Typography>
                <Typography className="hour-charge">
                {
                    invoiceData[0]
                        ? (
                            (invoiceData[0].Miles ? invoiceData[0].Miles : 0) *
                            (invoiceData[0].MileageRate ? invoiceData[0].MileageRate : 0)
                        ).toFixed(2)
                        : '0.00'
                }
                  </Typography>
              </Box>
            </Stack> */}

                {/* {invoiceTableData.map((invoiceDetail) => {

                  const totalHours = invoiceDetail.data.reduce((sum, row) => sum + (row.Hours || 0), 0);
                  const totalMiles = invoiceDetail.data.reduce((sum, row) => sum + (row.Miles || 0), 0);
                  const totalLodging = invoiceDetail.data.reduce((sum, row) => sum + (row.Lodging || 0), 0);
                  const totalCopies = invoiceDetail.data.reduce((sum, row) => sum + (row.Copies || 0), 0);
                  const totalMisc = invoiceDetail.data.reduce((sum, row) => sum + (row.Misc || 0), 0);
                  const totalPerDiem = invoiceDetail.data.reduce((sum, row) => sum + (row.PerDiem || 0), 0);


                return (
                  <TableContainer
                    sx={{ minHeight: "400px" }}
                    className="preview-table"
                    component={Paper}
                  >
                    <Typography className="address-title">
                      {invoiceDetail ? invoiceDetail.BrokerName : ""}
                    </Typography>

                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Date</TableCell>
                          <TableCell>Day Rate Type</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Hours</TableCell>
                          <TableCell>Miles</TableCell>
                          <TableCell>Lodging</TableCell>
                          <TableCell>Copies</TableCell>
                          <TableCell>Misc</TableCell>
                          <TableCell>Per Diem</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoiceDetail.data.map((invoiceDetail) => (
                          <TableRow
                            key={invoiceDataRow.BillingDetailID}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell>
                              <span>{invoiceDataRow.Date}</span>
                              <br />
                              <span className="pv-description">
                                {invoiceDataRow.Description || "No Description"}
                              </span>
                            </TableCell>
                            <TableCell>
                              {getPrintDayRateType(invoiceDataRow)}
                            </TableCell>
                            <TableCell>
                            { billTypeList.find((row) => row.id === invoiceDataRow.BillingType)?.name || "Unknown" }
                            </TableCell>
                            <TableCell>
                              {invoiceDataRow.Hours
                                ? invoiceDataRow.Hours.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            <TableCell>
                              $
                              {invoiceDataRow.Miles
                                ? invoiceDataRow.Miles.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            <TableCell>
                              {invoiceDataRow.Lodging
                                ? invoiceDataRow.Lodging.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            <TableCell>
                              {invoiceDataRow.Copies
                                ? invoiceDataRow.Copies.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            <TableCell>
                              {invoiceDataRow.Misc
                                ? invoiceDataRow.Misc.toFixed(2)
                                : "0.00"}
                            </TableCell>
                            <TableCell>
                              $
                              {invoiceDataRow.PerDiem
                                ? invoiceDataRow.PerDiem.toFixed(2)
                                : "0.00"}
                            </TableCell>
                          </TableRow>
                        ))}

                         <TableRow>
                        <TableCell colSpan={3}>Total</TableCell>
                        <TableCell><strong>{totalHours.toFixed(2)}</strong></TableCell>
                        <TableCell><strong>${totalMiles.toFixed(2)}</strong></TableCell>
                        <TableCell><strong>{totalLodging.toFixed(2)}</strong></TableCell>
                        <TableCell><strong>{totalCopies.toFixed(2)}</strong></TableCell>
                        <TableCell><strong>{totalMisc.toFixed(2)}</strong></TableCell>
                        <TableCell><strong>${totalPerDiem.toFixed(2)}</strong></TableCell>
                    </TableRow>

                      </TableBody>
                    </Table>
                  </TableContainer>
                );
              })} */}
                {/* {pdfViewer == true &&
                  fullPageView == true &&
                  previewDetails?.length > 0 && (
                    <>
                      <br />
                      <br />
                      <div>
                        <Typography variant="h6" className="address-title">
                          Attachments:
                        </Typography>

                        {previewDetails.map((file, index) => (
                          <Box
                            key={index}
                            sx={{
                              marginTop: "20px",
                              width: "210mm", // A4 width
                              height: "250mm", // A4 height
                              padding: "10mm",
                              border: "1px solid #ccc", // Optional border for the "page"
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "start",
                              alignItems: "start",
                              marginBottom: "20px", // Add spacing between rows
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              {file.fileName}
                            </Typography>

                            {["png", "jpg", "jpeg", "svg", "webp"].includes(
                              file.fileName.split(".").pop().toLowerCase()
                            ) && (
                              <img
                                src={file.filePath}
                                alt={file.fileName}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  maxHeight: "250mm",
                                  objectFit: "contain",
                                }}
                              />
                            )}

                            {file.fileName.split(".").pop().toLowerCase() ===
                                            "pdf" && (
                                            <embed
                                              src={file.filePath}
                                              type="application/pdf"
                                              width="100%"
                                              height="100%"
                                              style={{ objectFit: "contain" }}
                                            />
                                          )}
                          </Box>
                        ))}
                      </div>
                    </>
                  )} */}

                <br />
                <br />

                <Typography className="address-bar">
                  © 2018. HOS Resources, LLC. All Rights Reserved. 910 Harding
                  Street Lafayette, LA 70503 337-296-8032 www.hosresources.com
                </Typography>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="flex-start"
                  justifyContent="space-between"
                  className="preview-footer"
                >
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                      <span class="material-symbols-outlined">location_on</span>
                      <Typography>
                        910 Harding Street <br />
                        Lafayette, LA 70503
                      </Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                      <span class="material-symbols-outlined">mail</span>
                      <Typography>
                        P.O. Box 51794 <br />
                        Lafayette, LA 70505
                      </Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <span class="material-symbols-outlined">call</span>
                      <Typography>337.889.3941</Typography>
                    </Stack>
                  </Box>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <span className="material-symbols-outlined">public</span>
                      <Typography>www.hosresources.com</Typography>
                    </Stack>
                  </Box>
                </Stack>
              </div>
            </div>
            {loading && <CustomPageLoading />}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
